import { Trans, t } from "@lingui/macro";
import React, { useCallback, useMemo, useState } from "react";
import { toast } from "react-toastify";

import Checkbox from "components/Checkbox/Checkbox";
import Footer from "components/Footer/Footer";
import Modal from "components/Modal/Modal";
import Tooltip from "components/Tooltip/Tooltip";

import GlpManager from "sdk/abis/GlpManager.json";
import ReaderV2 from "sdk/abis/ReaderV2.json";
import RewardReader from "sdk/abis/RewardReader.json";
import RewardRouter from "sdk/abis/RewardRouter.json";
import Token from "sdk/abis/Token.json";
import Vault from "sdk/abis/Vault.json";
import Vester from "sdk/abis/Vester.json";

import cx from "classnames";
import { ARBITRUM, AVALANCHE, getChainName, getConstant } from "config/chains";
import { BASIS_POINTS_DIVISOR_BIGINT } from "config/factors";
import { SetPendingTransactions, useGmxPrice, useTotalGmxStaked, useTotalGmxSupply } from "domain/legacy";
import { ethers } from "ethers";
import {
  GLP_DECIMALS,
  PLACEHOLDER_ACCOUNT,
  getBalanceAndSupplyData,
  getDepositBalanceData,
  getPageTitle,
  getProcessedData,
  getStakingData,
  ProcessedData,
} from "lib/legacy";
import { USD_DECIMALS } from "config/factors";
import { MARKETS } from "config/static/markets";
import { Link } from "react-router-dom";

import useSWR from "swr";

import { getContract } from "config/contracts";

import { useConnectModal } from "@rainbow-me/rainbowkit";
import { AlertInfo } from "components/AlertInfo/AlertInfo";
import { ApproveTokenButton } from "components/ApproveTokenButton/ApproveTokenButton";
import Button from "components/Button/Button";
import BuyInputSection from "components/BuyInputSection/BuyInputSection";
import SEO from "components/Common/SEO";
import ExternalLink from "components/ExternalLink/ExternalLink";
import PageTitle from "components/PageTitle/PageTitle";
import GMXAprTooltip from "components/Stake/GMXAprTooltip";
import ChainsStatsTooltipRow from "components/StatsTooltip/ChainsStatsTooltipRow";
import StatsTooltipRow from "components/StatsTooltip/StatsTooltipRow";
import UserIncentiveDistributionList from "components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList";
import TooltipWithPortal from "components/Tooltip/TooltipWithPortal";
import { getServerUrl } from "config/backend";
import { getIsSyntheticsSupported } from "config/features";
import { getIcons } from "config/icons";
import { getIncentivesV2Url } from "config/links";
import { NATIVE_TOKEN_ADDRESS } from "config/tokens";
import { GLP_PRICE_DECIMALS, MAX_METAMASK_MOBILE_DECIMALS } from "config/ui";
import useIncentiveStats from "domain/synthetics/common/useIncentiveStats";
import { useGovTokenAmount } from "domain/synthetics/governance/useGovTokenAmount";
import { useGovTokenDelegates } from "domain/synthetics/governance/useGovTokenDelegates";
import { getTotalGmInfo, useMarketTokensData } from "domain/synthetics/markets";
import { useGmMarketsApy } from "domain/synthetics/markets/useGmMarketsApy";
import { useTokensAllowanceData } from "domain/synthetics/tokens";
import { useAnyAirdroppedTokenTitle } from "domain/synthetics/tokens/useAirdroppedTokenTitle";
import { approveTokens } from "domain/tokens";
import useVestingData from "domain/vesting/useVestingData";
import { bigMath } from "lib/bigmath";
import { useChainId } from "lib/chains";
import { callContract, contractFetcher } from "lib/contracts";
import { helperToast } from "lib/helperToast";
import { useENS } from "lib/legacy";
import { useLocalStorageSerializeKey } from "lib/localStorage";
import {
  BN_ZERO,
  expandDecimals,
  formatAmount,
  formatAmountFree,
  formatKeyAmount,
  limitDecimals,
  parseValue,
} from "lib/numbers";
import { UncheckedJsonRpcSigner } from "lib/rpc/UncheckedJsonRpcSigner";
import { usePendingTxns } from "lib/usePendingTxns";
import { shortenAddressOrEns } from "lib/wallets";
import useIsMetamaskMobile from "lib/wallets/useIsMetamaskMobile";
import useWallet from "lib/wallets/useWallet";
import "./StakeV2.css";
import { GMX_DAO_LINKS, getGmxDAODelegateLink } from "./constants";
import { GmList } from "components/Synthetics/GmList/GmList";

const { ZeroAddress } = ethers;

// function StakeModal(props: {
//   isVisible: boolean;
//   setIsVisible: (isVisible: boolean) => void;
//   chainId: number;
//   title: string;
//   maxAmount: bigint | undefined;
//   value: string;
//   setValue: (value: string) => void;
//   signer: UncheckedJsonRpcSigner | undefined;
//   stakingTokenSymbol: string;
//   stakingTokenAddress: string;
//   farmAddress: string;
//   rewardRouterAddress: string;
//   stakeMethodName: string;
//   setPendingTxns: SetPendingTransactions;
//   processedData: ProcessedData | undefined;
// }) {
//   const {
//     isVisible,
//     setIsVisible,
//     chainId,
//     title,
//     maxAmount,
//     value,
//     setValue,
//     signer,
//     stakingTokenSymbol,
//     stakingTokenAddress,
//     farmAddress,
//     rewardRouterAddress,
//     stakeMethodName,
//     setPendingTxns,
//     processedData,
//   } = props;
//
//   const govTokenAmount = useGovTokenAmount(chainId);
//   const govTokenDelegatesAddress = useGovTokenDelegates(chainId);
//   const isUndelegatedGovToken =
//     chainId === ARBITRUM && govTokenDelegatesAddress === NATIVE_TOKEN_ADDRESS && govTokenAmount && govTokenAmount > 0;
//
//   const [isStaking, setIsStaking] = useState(false);
//   const isMetamaskMobile = useIsMetamaskMobile();
//   const [isApproving, setIsApproving] = useState(false);
//   const icons = getIcons(chainId);
//   const { tokensAllowanceData } = useTokensAllowanceData(chainId, {
//     spenderAddress: farmAddress,
//     tokenAddresses: [stakingTokenAddress].filter(Boolean),
//   });
//   const tokenAllowance = tokensAllowanceData?.[stakingTokenAddress];
//
//   let amount = parseValue(value, 18);
//   const needApproval =
//     farmAddress !== ZeroAddress && tokenAllowance !== undefined && amount !== undefined && amount > tokenAllowance;
//
//   let stakeBonusPercentage: undefined | bigint = undefined;
//   if (
//     processedData &&
//     amount !== undefined &&
//     amount > 0 &&
//     processedData.esGmxInStakedGmx !== undefined &&
//     processedData.gmxInStakedGmx !== undefined
//   ) {
//     const divisor = processedData.esGmxInStakedGmx + processedData.gmxInStakedGmx;
//     if (divisor !== 0n) {
//       stakeBonusPercentage = bigMath.mulDiv(amount, BASIS_POINTS_DIVISOR_BIGINT, divisor);
//     }
//   }
//
//   const getError = () => {
//     if (amount === undefined || amount === 0n) {
//       return t`Enter an amount`;
//     }
//     if (maxAmount !== undefined && amount > maxAmount) {
//       return t`Max amount exceeded`;
//     }
//   };
//
//   const onClickPrimary = () => {
//     if (needApproval) {
//       approveTokens({
//         setIsApproving,
//         signer,
//         tokenAddress: stakingTokenAddress,
//         spender: farmAddress,
//         chainId,
//       });
//       return;
//     }
//
//     setIsStaking(true);
//     const contract = new ethers.Contract(rewardRouterAddress, RewardRouter.abi, signer);
//
//     callContract(chainId, contract, stakeMethodName, [amount], {
//       sentMsg: t`Stake submitted!`,
//       failMsg: t`Stake failed.`,
//       setPendingTxns,
//     })
//       .then(() => {
//         setIsVisible(false);
//       })
//       .finally(() => {
//         setIsStaking(false);
//       });
//   };
//
//   const isPrimaryEnabled = () => {
//     const error = getError();
//     if (error) {
//       return false;
//     }
//     if (isApproving || needApproval) {
//       return false;
//     }
//     if (isStaking) {
//       return false;
//     }
//     if (isUndelegatedGovToken) {
//       return false;
//     }
//     return true;
//   };
//
//   const getPrimaryText = () => {
//     const error = getError();
//     if (error) {
//       return error;
//     }
//     if (isApproving || needApproval) {
//       return t`Pending ${stakingTokenSymbol} approval`;
//     }
//     if (isStaking) {
//       return t`Staking...`;
//     }
//     return t`Stake`;
//   };
//
//   return (
//     <div className="StakeModal">
//       <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={title}>
//         <BuyInputSection
//           topLeftLabel={t`Stake`}
//           topRightLabel={t`Max`}
//           topRightValue={formatAmount(maxAmount, 18, 4, true)}
//           onClickTopRightLabel={() => {
//             if (maxAmount === undefined) return;
//             const formattedMaxAmount = formatAmountFree(maxAmount, 18, 18);
//             const finalMaxAmount = isMetamaskMobile
//               ? limitDecimals(formattedMaxAmount, MAX_METAMASK_MOBILE_DECIMALS)
//               : formattedMaxAmount;
//             setValue(finalMaxAmount);
//           }}
//           inputValue={value}
//           onInputValueChange={(e) => setValue(e.target.value)}
//           showMaxButton={false}
//         >
//           <div className="Stake-modal-icons">
//             <img
//               className="icon mr-5 h-22"
//               height="22"
//               src={icons?.[stakingTokenSymbol.toLowerCase()]}
//               alt={stakingTokenSymbol}
//             />
//             {stakingTokenSymbol}
//           </div>
//         </BuyInputSection>
//
//         {(needApproval || isApproving) && (
//           <div className="mb-12">
//             <ApproveTokenButton
//               tokenAddress={stakingTokenAddress}
//               spenderAddress={farmAddress}
//               tokenSymbol={stakingTokenSymbol}
//               isApproved={!needApproval}
//             />
//           </div>
//         )}
//
//         {stakeBonusPercentage !== undefined &&
//           stakeBonusPercentage > 0 &&
//           amount !== undefined &&
//           maxAmount !== undefined &&
//           amount <= maxAmount && (
//             <AlertInfo type="info">
//               <Trans>You will earn {formatAmount(stakeBonusPercentage, 2, 2)}% more rewards with this action.</Trans>
//             </AlertInfo>
//           )}
//
//         {isUndelegatedGovToken ? (
//           <AlertInfo type="warning" className={cx("DelegateGMXAlertInfo")} textColor="text-yellow-500">
//             <Trans>
//               <ExternalLink href={GMX_DAO_LINKS.VOTING_POWER} className="display-inline">
//                 Delegate your undelegated {formatAmount(govTokenAmount, 18, 2, true)} TMX DAO
//               </ExternalLink>{" "}
//               voting power before staking.
//             </Trans>
//           </AlertInfo>
//         ) : null}
//
//         <div className="Exchange-swap-button-container">
//           <Button variant="primary-action" className="w-full" onClick={onClickPrimary} disabled={!isPrimaryEnabled()}>
//             {getPrimaryText()}
//           </Button>
//         </div>
//       </Modal>
//     </div>
//   );
// }
//
// function UnstakeModal(props: {
//   isVisible: boolean;
//   setIsVisible: (isVisible: boolean) => void;
//   chainId: number;
//   title: string;
//   maxAmount: bigint | undefined;
//   value: string;
//   setValue: (value: string) => void;
//   signer: UncheckedJsonRpcSigner | undefined;
//   unstakingTokenSymbol: string;
//   rewardRouterAddress: string;
//   unstakeMethodName: string;
//   reservedAmount: bigint | undefined;
//   setPendingTxns: SetPendingTransactions;
//   processedData: ProcessedData | undefined;
// }) {
//   const {
//     isVisible,
//     setIsVisible,
//     chainId,
//     title,
//     maxAmount,
//     value,
//     setValue,
//     signer,
//     unstakingTokenSymbol,
//     rewardRouterAddress,
//     unstakeMethodName,
//     reservedAmount,
//     setPendingTxns,
//     processedData,
//   } = props;
//   const [isUnstaking, setIsUnstaking] = useState(false);
//   const icons = getIcons(chainId);
//
//   let amount = parseValue(value, 18);
//
//   let unstakeBonusLostPercentage: undefined | bigint = undefined;
//   if (
//     processedData &&
//     amount !== undefined &&
//     amount > 0 &&
//     processedData.esGmxInStakedGmx !== undefined &&
//     processedData.gmxInStakedGmx !== undefined
//   ) {
//     const divisor = processedData.esGmxInStakedGmx + processedData.gmxInStakedGmx;
//     if (divisor !== 0n) {
//       unstakeBonusLostPercentage = bigMath.mulDiv(amount, BASIS_POINTS_DIVISOR_BIGINT, divisor);
//     }
//   }
//
//   const votingPowerBurnAmount = amount;
//
//   const getError = () => {
//     if (amount === undefined || amount === 0n) {
//       return t`Enter an amount`;
//     }
//     if (maxAmount !== undefined && amount > maxAmount) {
//       return t`Max amount exceeded`;
//     }
//   };
//
//   const onClickPrimary = () => {
//     setIsUnstaking(true);
//     const contract = new ethers.Contract(rewardRouterAddress, RewardRouter.abi, signer);
//     callContract(chainId, contract, unstakeMethodName, [amount], {
//       sentMsg: t`Unstake submitted!`,
//       failMsg: t`Unstake failed.`,
//       successMsg: t`Unstake completed!`,
//       setPendingTxns,
//     })
//       .then(() => {
//         setIsVisible(false);
//       })
//       .finally(() => {
//         setIsUnstaking(false);
//       });
//   };
//
//   const isPrimaryEnabled = () => {
//     const error = getError();
//     if (error) {
//       return false;
//     }
//     if (isUnstaking) {
//       return false;
//     }
//     return true;
//   };
//
//   const getPrimaryText = () => {
//     const error = getError();
//     if (error) {
//       return error;
//     }
//     if (isUnstaking) {
//       return t`Unstaking...`;
//     }
//     return t`Unstake`;
//   };
//
//   return (
//     <div className="StakeModal">
//       <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={title}>
//         <BuyInputSection
//           topLeftLabel={t`Unstake`}
//           topRightLabel={t`Max`}
//           topRightValue={formatAmount(maxAmount, 18, 4, true)}
//           onClickTopRightLabel={() => maxAmount !== undefined && setValue(formatAmountFree(maxAmount, 18, 18))}
//           inputValue={value}
//           onInputValueChange={(e) => setValue(e.target.value)}
//           showMaxButton={false}
//         >
//           <div className="Stake-modal-icons">
//             <img
//               className="icon mr-5 h-22"
//               height="22"
//               src={icons?.[unstakingTokenSymbol.toLowerCase()]}
//               alt={unstakingTokenSymbol}
//             />
//             {unstakingTokenSymbol}
//           </div>
//         </BuyInputSection>
//         {reservedAmount !== undefined && reservedAmount > 0 && (
//           <AlertInfo type="info">
//             You have {formatAmount(reservedAmount, 18, 2, true)} tokens reserved for vesting.
//           </AlertInfo>
//         )}
//         {unstakeBonusLostPercentage !== undefined &&
//           unstakeBonusLostPercentage > 0 &&
//           amount !== undefined &&
//           maxAmount !== undefined &&
//           amount <= maxAmount && (
//             <AlertInfo type="warning">
//               <Trans>
//                 {chainId === ARBITRUM ? (
//                   <span>
//                     Unstaking will burn {formatAmount(votingPowerBurnAmount, 18, 2, true)} voting power.&nbsp;
//                   </span>
//                 ) : null}
//                 <span>
//                   You will earn {formatAmount(unstakeBonusLostPercentage, 2, 2)}% less rewards with this action.
//                 </span>
//               </Trans>
//             </AlertInfo>
//           )}
//         <div className="Exchange-swap-button-container">
//           <Button variant="primary-action" className="w-full" onClick={onClickPrimary} disabled={!isPrimaryEnabled()}>
//             {getPrimaryText()}
//           </Button>
//         </div>
//       </Modal>
//     </div>
//   );
// }
//
// function VesterDepositModal(props: {
//   isVisible: boolean;
//   setIsVisible: (isVisible: boolean) => void;
//   chainId: number;
//   title: string;
//   maxAmount: bigint | undefined;
//   value: string;
//   setValue: (value: string) => void;
//   balance: bigint | undefined;
//   vestedAmount: bigint | undefined;
//   averageStakedAmount: bigint | undefined;
//   maxVestableAmount: bigint | undefined;
//   signer: UncheckedJsonRpcSigner | undefined;
//   stakeTokenLabel: string;
//   reserveAmount: bigint | undefined;
//   maxReserveAmount: bigint | undefined;
//   vesterAddress: string;
//   setPendingTxns: SetPendingTransactions;
// }) {
//   const {
//     isVisible,
//     setIsVisible,
//     chainId,
//     title,
//     maxAmount,
//     value,
//     setValue,
//     balance,
//     vestedAmount,
//     averageStakedAmount,
//     maxVestableAmount,
//     signer,
//     stakeTokenLabel,
//     reserveAmount,
//     maxReserveAmount,
//     vesterAddress,
//     setPendingTxns,
//   } = props;
//   const [isDepositing, setIsDepositing] = useState(false);
//   const icons = getIcons(chainId);
//
//   let amount = parseValue(value, 18);
//
//   let nextReserveAmount: bigint | undefined = reserveAmount;
//
//   let nextDepositAmount = vestedAmount;
//   if (amount !== undefined && vestedAmount !== undefined) {
//     nextDepositAmount = vestedAmount + amount;
//   }
//
//   let additionalReserveAmount = 0n;
//   if (
//     amount !== undefined &&
//     nextDepositAmount !== undefined &&
//     averageStakedAmount !== undefined &&
//     maxVestableAmount !== undefined &&
//     maxVestableAmount > 0 &&
//     nextReserveAmount !== undefined
//   ) {
//     nextReserveAmount = bigMath.mulDiv(nextDepositAmount, averageStakedAmount, maxVestableAmount);
//     if (reserveAmount !== undefined && nextReserveAmount > reserveAmount) {
//       additionalReserveAmount = nextReserveAmount - reserveAmount;
//     }
//   }
//
//   const getError = () => {
//     if (amount === undefined) {
//       return t`Enter an amount`;
//     }
//     if (maxAmount !== undefined && amount > maxAmount) {
//       return t`Max amount exceeded`;
//     }
//     if (maxReserveAmount !== undefined && nextReserveAmount !== undefined && nextReserveAmount > maxReserveAmount) {
//       return t`Insufficient staked tokens`;
//     }
//   };
//
//   const onClickPrimary = () => {
//     setIsDepositing(true);
//     const contract = new ethers.Contract(vesterAddress, Vester.abi, signer);
//
//     callContract(chainId, contract, "deposit", [amount], {
//       sentMsg: t`Deposit submitted!`,
//       failMsg: t`Deposit failed!`,
//       successMsg: t`Deposited!`,
//       setPendingTxns,
//     })
//       .then(() => {
//         setIsVisible(false);
//       })
//       .finally(() => {
//         setIsDepositing(false);
//       });
//   };
//
//   const isPrimaryEnabled = () => {
//     const error = getError();
//     if (error) {
//       return false;
//     }
//     if (isDepositing) {
//       return false;
//     }
//     return true;
//   };
//
//   const getPrimaryText = () => {
//     const error = getError();
//     if (error) {
//       return error;
//     }
//     if (isDepositing) {
//       return t`Depositing...`;
//     }
//     return t`Deposit`;
//   };
//
//   return (
//     <SEO title={getPageTitle(t`Earn`)}>
//       <div className="StakeModal">
//         <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={title} className="non-scrollable">
//           <BuyInputSection
//             topLeftLabel={t`Deposit`}
//             topRightLabel={t`Max`}
//             topRightValue={formatAmount(maxAmount, 18, 4, true)}
//             onClickTopRightLabel={() => maxAmount !== undefined && setValue(formatAmountFree(maxAmount, 18, 18))}
//             inputValue={value}
//             onInputValueChange={(e) => setValue(e.target.value)}
//             showMaxButton={false}
//           >
//             <div className="Stake-modal-icons">
//               <img className="icon mr-5 h-22" height="22" src={icons?.esgmx} alt="esTMX" />
//               esTMX
//             </div>
//           </BuyInputSection>
//
//           <div className="VesterDepositModal-info-rows">
//             <div className="Exchange-info-row">
//               <div className="Exchange-info-label">
//                 <Trans>Wallet</Trans>
//               </div>
//               <div className="align-right">{formatAmount(balance, 18, 2, true)} esTMX</div>
//             </div>
//             <div className="Exchange-info-row">
//               <div className="Exchange-info-label">
//                 <Trans>Vault Capacity</Trans>
//               </div>
//               <div className="align-right">
//                 <TooltipWithPortal
//                   handle={`${formatAmount(nextDepositAmount, 18, 2, true)} / ${formatAmount(
//                     maxVestableAmount,
//                     18,
//                     2,
//                     true
//                   )}`}
//                   position="top-end"
//                   renderContent={() => {
//                     return (
//                       <div>
//                         <p className="text-white">
//                           <Trans>Vault Capacity for your Account:</Trans>
//                         </p>
//                         <br />
//                         <StatsTooltipRow
//                           showDollar={false}
//                           label={t`Deposited`}
//                           value={`${formatAmount(vestedAmount, 18, 2, true)} esTMX`}
//                         />
//                         <StatsTooltipRow
//                           showDollar={false}
//                           label={t`Max Capacity`}
//                           value={`${formatAmount(maxVestableAmount, 18, 2, true)} esTMX`}
//                         />
//                       </div>
//                     );
//                   }}
//                 />
//               </div>
//             </div>
//             {reserveAmount !== undefined && (
//               <div className="Exchange-info-row">
//                 <div className="Exchange-info-label">
//                   <Trans>Reserve Amount</Trans>
//                 </div>
//                 <div className="align-right">
//                   <TooltipWithPortal
//                     handle={`${formatAmount(
//                       nextReserveAmount,
//                       18,
//                       2,
//                       true
//                     )} / ${formatAmount(maxReserveAmount, 18, 2, true)}`}
//                     position="top-end"
//                     renderContent={() => {
//                       return (
//                         <>
//                           <StatsTooltipRow
//                             label={t`Current Reserved`}
//                             value={formatAmount(reserveAmount, 18, 2, true)}
//                             showDollar={false}
//                           />
//                           <StatsTooltipRow
//                             label={t`Additional reserve required`}
//                             value={formatAmount(additionalReserveAmount, 18, 2, true)}
//                             showDollar={false}
//                           />
//                           {amount !== undefined &&
//                             nextReserveAmount !== undefined &&
//                             maxReserveAmount !== undefined &&
//                             nextReserveAmount > maxReserveAmount && (
//                               <>
//                                 <br />
//                                 <Trans>
//                                   You need a total of at least {formatAmount(nextReserveAmount, 18, 2, true)}{" "}
//                                   {stakeTokenLabel} to vest {formatAmount(amount, 18, 2, true)} esTMX.
//                                 </Trans>
//                               </>
//                             )}
//                         </>
//                       );
//                     }}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>
//           <div className="Exchange-swap-button-container">
//             <Button variant="primary-action" className="w-full" onClick={onClickPrimary} disabled={!isPrimaryEnabled()}>
//               {getPrimaryText()}
//             </Button>
//           </div>
//         </Modal>
//       </div>
//     </SEO>
//   );
// }
//
// function VesterWithdrawModal(props: {
//   isVisible: boolean;
//   setIsVisible: (isVisible: boolean) => void;
//   chainId: number;
//   title: string;
//   signer: UncheckedJsonRpcSigner | undefined;
//   vesterAddress: string;
//   setPendingTxns: SetPendingTransactions;
// }) {
//   const { isVisible, setIsVisible, chainId, title, signer, vesterAddress, setPendingTxns } = props;
//   const [isWithdrawing, setIsWithdrawing] = useState(false);
//
//   const onClickPrimary = () => {
//     setIsWithdrawing(true);
//     const contract = new ethers.Contract(vesterAddress, Vester.abi, signer);
//
//     callContract(chainId, contract, "withdraw", [], {
//       sentMsg: t`Withdraw submitted.`,
//       failMsg: t`Withdraw failed.`,
//       successMsg: t`Withdrawn!`,
//       setPendingTxns,
//     })
//       .then(() => {
//         setIsVisible(false);
//       })
//       .finally(() => {
//         setIsWithdrawing(false);
//       });
//   };
//
//   return (
//     <div className="StakeModal">
//       <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={title}>
//         <Trans>
//           <div>
//             This will withdraw and unreserve all tokens as well as pause vesting.
//             <br />
//             <br />
//             esTMX tokens that have been converted to TMX will be claimed and remain as TMX tokens.
//             <br />
//             <br />
//             To claim TMX tokens without withdrawing, use the "Claim" button under the Total Rewards section.
//             <br />
//             <br />
//           </div>
//         </Trans>
//         <div className="Exchange-swap-button-container">
//           <Button variant="primary-action" className="w-full" onClick={onClickPrimary} disabled={isWithdrawing}>
//             {!isWithdrawing && "Confirm Withdraw"}
//             {isWithdrawing && "Confirming..."}
//           </Button>
//         </div>
//       </Modal>
//     </div>
//   );
// }
//
// function AffiliateVesterWithdrawModal(props) {
//   const { isVisible, setIsVisible, chainId, signer, setPendingTxns } = props;
//   const [isWithdrawing, setIsWithdrawing] = useState(false);
//
//   const affiliateVesterAddress = getContract(chainId, "AffiliateVester");
//
//   const onClickPrimary = () => {
//     setIsWithdrawing(true);
//     const contract = new ethers.Contract(affiliateVesterAddress, Vester.abi, signer);
//
//     callContract(chainId, contract, "withdraw", [], {
//       sentMsg: t`Withdraw submitted.`,
//       failMsg: t`Withdraw failed.`,
//       successMsg: t`Withdrawn!`,
//       setPendingTxns,
//     })
//       .then(() => {
//         setIsVisible(false);
//       })
//       .finally(() => {
//         setIsWithdrawing(false);
//       });
//   };
//
//   return (
//     <div className="StakeModal">
//       <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={t`Withdraw from Affiliate Vault`}>
//         <Trans>
//           <div>
//             This will withdraw all esTMX tokens as well as pause vesting.
//             <br />
//             <br />
//             esTMX tokens that have been converted to TMX will be claimed and remain as TMX tokens.
//             <br />
//             <br />
//             To claim TMX tokens without withdrawing, use the "Claim" button.
//             <br />
//             <br />
//           </div>
//         </Trans>
//         <div className="Exchange-swap-button-container">
//           <Button variant="primary-action" className="w-full" onClick={onClickPrimary} disabled={isWithdrawing}>
//             {!isWithdrawing && "Confirm Withdraw"}
//             {isWithdrawing && "Confirming..."}
//           </Button>
//         </div>
//       </Modal>
//     </div>
//   );
// }
//
// function ClaimModal(props: {
//   isVisible: boolean;
//   setIsVisible: (isVisible: boolean) => void;
//   rewardRouterAddress: string;
//   signer: UncheckedJsonRpcSigner | undefined;
//   chainId: number;
//   setPendingTxns: SetPendingTransactions;
//   totalGmxRewards: bigint | undefined;
//   nativeTokenSymbol: string;
//   wrappedTokenSymbol: string;
//   isNativeTokenToClaim?: boolean;
//   gmxUsageOptionsMsg?: React.ReactNode;
//   onClaimSuccess?: () => void;
// }) {
//   const {
//     isVisible,
//     setIsVisible,
//     rewardRouterAddress,
//     signer,
//     chainId,
//     setPendingTxns,
//     totalGmxRewards,
//     nativeTokenSymbol,
//     wrappedTokenSymbol,
//     isNativeTokenToClaim,
//     gmxUsageOptionsMsg,
//     onClaimSuccess,
//   } = props;
//   const [isClaiming, setIsClaiming] = useState(false);
//   const [shouldClaimGmx, setShouldClaimGmx] = useLocalStorageSerializeKey(
//     [chainId, "StakeV2-compound-should-claim-gmx"],
//     true
//   );
//   const [shouldStakeGmx, setShouldStakeGmx] = useLocalStorageSerializeKey(
//     [chainId, "StakeV2-compound-should-stake-gmx"],
//     true
//   );
//   const [shouldClaimEsGmx, setShouldClaimEsGmx] = useLocalStorageSerializeKey(
//     [chainId, "StakeV2-compound-should-claim-es-gmx"],
//     true
//   );
//   const [shouldStakeEsGmx, setShouldStakeEsGmx] = useLocalStorageSerializeKey(
//     [chainId, "StakeV2-compound-should-stake-es-gmx"],
//     true
//   );
//   const [shouldClaimWeth, setShouldClaimWeth] = useLocalStorageSerializeKey(
//     [chainId, "StakeV2-compound-should-claim-weth"],
//     true
//   );
//   const [shouldConvertWeth, setShouldConvertWeth] = useLocalStorageSerializeKey(
//     [chainId, "StakeV2-compound-should-convert-weth"],
//     true
//   );
//
//   const govTokenAmount = useGovTokenAmount(chainId);
//   const govTokenDelegatesAddress = useGovTokenDelegates(chainId);
//   const isUndelegatedGovToken =
//     chainId === ARBITRUM && govTokenDelegatesAddress === NATIVE_TOKEN_ADDRESS && govTokenAmount && govTokenAmount > 0;
//
//   const gmxAddress = getContract(chainId, "GMX");
//   const stakedGmxTrackerAddress = getContract(chainId, "StakedGmxTracker");
//
//   const [isApproving, setIsApproving] = useState(false);
//
//   const { tokensAllowanceData: gmxAllowanceData } = useTokensAllowanceData(chainId, {
//     spenderAddress: stakedGmxTrackerAddress,
//     tokenAddresses: [gmxAddress],
//   });
//
//   const gmxTokenAllowance = gmxAllowanceData?.[gmxAddress];
//
//   const needApproval =
//     shouldStakeGmx &&
//     totalGmxRewards !== undefined &&
//     ((gmxTokenAllowance !== undefined && totalGmxRewards > gmxTokenAllowance) ||
//       (totalGmxRewards > 0n && gmxTokenAllowance === undefined));
//
//   const isPrimaryEnabled = () => {
//     return !isClaiming && !isApproving && !needApproval && !isUndelegatedGovToken;
//   };
//
//   const getPrimaryText = () => {
//     if (needApproval || isApproving) {
//       return t`Pending TMX approval`;
//     }
//
//     if (isClaiming) {
//       return t`Claiming...`;
//     }
//     return t`Claim`;
//   };
//
//   const onClickPrimary = () => {
//     if (needApproval) {
//       approveTokens({
//         setIsApproving,
//         signer,
//         tokenAddress: gmxAddress,
//         spender: stakedGmxTrackerAddress,
//         chainId,
//       });
//       return;
//     }
//
//     setIsClaiming(true);
//
//     const contract = new ethers.Contract(rewardRouterAddress, RewardRouter.abi, signer);
//     callContract(
//       chainId,
//       contract,
//       "handleRewards",
//       [
//         shouldClaimGmx || shouldStakeGmx,
//         shouldStakeGmx,
//         shouldClaimEsGmx || shouldStakeEsGmx,
//         shouldStakeEsGmx,
//         true,
//         isNativeTokenToClaim ? shouldClaimWeth || shouldConvertWeth : false,
//         isNativeTokenToClaim ? shouldConvertWeth : false,
//       ],
//       {
//         sentMsg: t`Claim submitted!`,
//         failMsg: t`Claim failed.`,
//         successMsg: t`Claim completed!`,
//         successDetailsMsg: !shouldStakeGmx ? gmxUsageOptionsMsg : undefined,
//         setPendingTxns,
//       }
//     )
//       .then(() => {
//         setIsVisible(false);
//         onClaimSuccess?.();
//       })
//       .finally(() => {
//         setIsClaiming(false);
//       });
//   };
//
//   const toggleShouldStakeGmx = (value) => {
//     if (value) {
//       setShouldClaimGmx(true);
//     }
//     setShouldStakeGmx(value);
//   };
//
//   const toggleShouldStakeEsGmx = (value) => {
//     if (value) {
//       setShouldClaimEsGmx(true);
//     }
//     setShouldStakeEsGmx(value);
//   };
//
//   const toggleConvertWeth = (value) => {
//     if (value) {
//       setShouldClaimWeth(true);
//     }
//     setShouldConvertWeth(value);
//   };
//
//   return (
//     <div className="StakeModal">
//       <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={t`Claim Rewards`}>
//         <div className="CompoundModal-menu">
//           <div>
//             <Checkbox isChecked={shouldClaimGmx} setIsChecked={setShouldClaimGmx} disabled={shouldStakeGmx}>
//               <Trans>Claim TMX Rewards</Trans>
//             </Checkbox>
//           </div>
//           <div>
//             <Checkbox isChecked={shouldStakeGmx} setIsChecked={toggleShouldStakeGmx}>
//               <Trans>Stake TMX Rewards</Trans>
//             </Checkbox>
//           </div>
//           <div>
//             <Checkbox isChecked={shouldClaimEsGmx} setIsChecked={setShouldClaimEsGmx} disabled={shouldStakeEsGmx}>
//               <Trans>Claim esTMX Rewards</Trans>
//             </Checkbox>
//           </div>
//           <div>
//             <Checkbox isChecked={shouldStakeEsGmx} setIsChecked={toggleShouldStakeEsGmx}>
//               <Trans>Stake esTMX Rewards</Trans>
//             </Checkbox>
//           </div>
//           {isNativeTokenToClaim && (
//             <>
//               <div>
//                 <Checkbox isChecked={shouldClaimWeth} setIsChecked={setShouldClaimWeth} disabled={shouldConvertWeth}>
//                   <Trans>Claim {wrappedTokenSymbol} Rewards</Trans>
//                 </Checkbox>
//               </div>
//               <div>
//                 <Checkbox isChecked={shouldConvertWeth} setIsChecked={toggleConvertWeth}>
//                   <Trans>
//                     Convert {wrappedTokenSymbol} to {nativeTokenSymbol}
//                   </Trans>
//                 </Checkbox>
//               </div>
//             </>
//           )}
//         </div>
//         {(needApproval || isApproving) && (
//           <div className="mb-12">
//             <ApproveTokenButton
//               tokenAddress={gmxAddress}
//               spenderAddress={stakedGmxTrackerAddress}
//               tokenSymbol={"GMX"}
//               isApproved={!needApproval}
//             />
//           </div>
//         )}
//         {isUndelegatedGovToken ? (
//           <AlertInfo type="warning" className={cx("DelegateGMXAlertInfo")} textColor="text-yellow-500">
//             <Trans>
//               <ExternalLink href={GMX_DAO_LINKS.VOTING_POWER} className="display-inline">
//                 Delegate your undelegated {formatAmount(govTokenAmount, 18, 2, true)} TMX DAO
//               </ExternalLink>
//               voting power before claiming.
//             </Trans>
//           </AlertInfo>
//         ) : null}
//         <div className="Exchange-swap-button-container">
//           <Button variant="primary-action" className="w-full" onClick={onClickPrimary} disabled={!isPrimaryEnabled()}>
//             {getPrimaryText()}
//           </Button>
//         </div>
//       </Modal>
//     </div>
//   );
// }
//
// function AffiliateClaimModal(props: {
//   isVisible: boolean;
//   setIsVisible: (isVisible: boolean) => void;
//   signer: UncheckedJsonRpcSigner | undefined;
//   chainId: number;
//   setPendingTxns: SetPendingTransactions;
//   totalVesterRewards: bigint | undefined;
// }) {
//   const { isVisible, setIsVisible, signer, chainId, setPendingTxns, totalVesterRewards } = props;
//   const [isClaiming, setIsClaiming] = useState(false);
//   const affiliateVesterAddress = getContract(chainId, "AffiliateVester");
//
//   const isPrimaryEnabled = () => {
//     if (totalVesterRewards == undefined || totalVesterRewards == 0n) {
//       return false;
//     }
//
//     return !isClaiming;
//   };
//
//   const getPrimaryText = () => {
//     if (isClaiming) {
//       return t`Claiming...`;
//     }
//     return t`Claim`;
//   };
//
//   const onClickPrimary = () => {
//     setIsClaiming(true);
//
//     const affiliateVesterContract = new ethers.Contract(affiliateVesterAddress, Vester.abi, signer);
//
//     callContract(chainId, affiliateVesterContract, "claim", [], {
//       sentMsg: t`Claim submitted.`,
//       failMsg: t`Claim failed.`,
//       successMsg: t`Claim completed!`,
//       setPendingTxns,
//     })
//       .then(() => {
//         setIsVisible(false);
//       })
//       .finally(() => {
//         setIsClaiming(false);
//       });
//   };
//
//   return (
//     <div className="StakeModal">
//       <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={t`Claim Affiliate Vault Rewards`}>
//         <Trans>
//           <div>
//             This will claim {formatAmount(totalVesterRewards, 18, 4, true)} TMX.
//             <br />
//             <br />
//             After claiming, you can stake these TMX tokens by using the "Stake" button in the TMX section of this Earn
//             page.
//             <br />
//             <br />
//           </div>
//         </Trans>
//         <div className="Exchange-swap-button-container">
//           <Button variant="primary-action" className="w-full" onClick={onClickPrimary} disabled={!isPrimaryEnabled()}>
//             {getPrimaryText()}
//           </Button>
//         </div>
//       </Modal>
//     </div>
//   );
// }

export default function StakeV2() {
  const { active, signer, account } = useWallet();
  const { chainId } = useChainId();
  const { openConnectModal } = useConnectModal();
  // const incentiveStats = useIncentiveStats(chainId);
  // const incentivesMessage = useMemo(() => {
  //   const avalancheLink = (
  //     <ExternalLink newTab href={"#"}>
  //       {/*<ExternalLink newTab href={getIncentivesV2Url(AVALANCHE)}>*/}
  //       {getChainName(AVALANCHE)}
  //     </ExternalLink>
  //   );
  //   if (incentiveStats?.lp?.isActive && incentiveStats?.trading?.isActive) {
  //     return (
  //       <div>
  //         <Trans>Liquidity and trading incentives programs are live on {avalancheLink}.</Trans>
  //       </div>
  //     );
  //   } else if (incentiveStats?.lp?.isActive) {
  //     return (
  //       <div>
  //         <Trans>Liquidity incentives program is live on {avalancheLink}.</Trans>
  //       </div>
  //     );
  //   } else if (incentiveStats?.trading?.isActive) {
  //     return (
  //       <div>
  //         <Trans>Trading incentives program is live on {avalancheLink}.</Trans>
  //       </div>
  //     );
  //   }
  // }, [incentiveStats?.lp?.isActive, incentiveStats?.trading?.isActive]);

  // const incentivesToken = useAnyAirdroppedTokenTitle();

  const [, setPendingTxns] = usePendingTxns();

  const icons = getIcons(chainId);
  const hasInsurance = false;
  const [isStakeGmxModalVisible, setIsStakeGmxModalVisible] = useState(false);
  const [stakeGmxValue, setStakeGmxValue] = useState("");
  const [isStakeEsGmxModalVisible, setIsStakeEsGmxModalVisible] = useState(false);
  const [stakeEsGmxValue, setStakeEsGmxValue] = useState("");

  const [isUnstakeModalVisible, setIsUnstakeModalVisible] = useState(false);
  const [unstakeModalTitle, setUnstakeModalTitle] = useState("");
  const [unstakeModalMaxAmount, setUnstakeModalMaxAmount] = useState<bigint | undefined>(undefined);
  const [unstakeValue, setUnstakeValue] = useState("");
  const [unstakingTokenSymbol, setUnstakingTokenSymbol] = useState("");
  const [unstakeMethodName, setUnstakeMethodName] = useState("");

  const [isVesterDepositModalVisible, setIsVesterDepositModalVisible] = useState(false);
  const [vesterDepositTitle, setVesterDepositTitle] = useState("");
  const [vesterDepositStakeTokenLabel, setVesterDepositStakeTokenLabel] = useState("");
  const [vesterDepositMaxAmount, setVesterDepositMaxAmount] = useState<bigint | undefined>();
  const [vesterDepositBalance, setVesterDepositBalance] = useState<bigint | undefined>();
  const [vesterDepositVestedAmount, setVesterDepositVestedAmount] = useState<bigint | undefined>();
  const [vesterDepositAverageStakedAmount, setVesterDepositAverageStakedAmount] = useState<bigint | undefined | string>(
    ""
  );
  const [vesterDepositMaxVestableAmount, setVesterDepositMaxVestableAmount] = useState<bigint | undefined>();
  const [vesterDepositValue, setVesterDepositValue] = useState("");
  const [vesterDepositReserveAmount, setVesterDepositReserveAmount] = useState<bigint | undefined>();
  const [vesterDepositMaxReserveAmount, setVesterDepositMaxReserveAmount] = useState<bigint | undefined>();
  const [vesterDepositAddress, setVesterDepositAddress] = useState("");

  const [isVesterWithdrawModalVisible, setIsVesterWithdrawModalVisible] = useState(false);
  const [isAffiliateVesterWithdrawModalVisible, setIsAffiliateVesterWithdrawModalVisible] = useState(false);
  const [vesterWithdrawTitle, setVesterWithdrawTitle] = useState("");
  const [vesterWithdrawAddress, setVesterWithdrawAddress] = useState("");

  const [isCompoundModalVisible, setIsCompoundModalVisible] = useState(false);
  const [isAffiliateClaimModalVisible, setIsAffiliateClaimModalVisible] = useState(false);

  const rewardRouterAddress = getContract(chainId, "RewardRouter");
  const rewardReaderAddress = getContract(chainId, "RewardReader");
  const readerAddress = getContract(chainId, "Reader");

  const vaultAddress = getContract(chainId, "Vault");
  const nativeTokenAddress = getContract(chainId, "NATIVE_TOKEN");
  const gmxAddress = getContract(chainId, "GMX");
  const esGmxAddress = getContract(chainId, "ES_GMX");
  const bnGmxAddress = getContract(chainId, "BN_GMX");
  const glpAddress = getContract(chainId, "GLP");

  const stakedGmxTrackerAddress = getContract(chainId, "StakedGmxTracker");
  const bonusGmxTrackerAddress = getContract(chainId, "BonusGmxTracker");
  const feeGmxTrackerAddress = getContract(chainId, "FeeGmxTracker");

  const stakedGlpTrackerAddress = getContract(chainId, "StakedGlpTracker");
  const feeGlpTrackerAddress = getContract(chainId, "FeeGlpTracker");
  const extendedGmxTrackerAddress = getContract(chainId, "ExtendedGmxTracker");

  const glpManagerAddress = getContract(chainId, "GlpManager");

  const stakedGmxDistributorAddress = getContract(chainId, "StakedGmxDistributor");
  const stakedGlpDistributorAddress = getContract(chainId, "StakedGlpDistributor");

  const gmxVesterAddress = getContract(chainId, "GmxVester");
  const glpVesterAddress = getContract(chainId, "GlpVester");
  const affiliateVesterAddress = getContract(chainId, "AffiliateVester");

  const excludedEsGmxAccounts = [stakedGmxDistributorAddress, stakedGlpDistributorAddress];

  const nativeTokenSymbol = getConstant(chainId, "nativeTokenSymbol");
  const wrappedTokenSymbol = getConstant(chainId, "wrappedTokenSymbol");

  const walletTokens = [gmxAddress, esGmxAddress, glpAddress, stakedGmxTrackerAddress];
  const depositTokens = [
    gmxAddress,
    esGmxAddress,
    stakedGmxTrackerAddress,
    extendedGmxTrackerAddress,
    bnGmxAddress,
    glpAddress,
  ];
  const rewardTrackersForDepositBalances = [
    stakedGmxTrackerAddress,
    stakedGmxTrackerAddress,
    bonusGmxTrackerAddress,
    feeGmxTrackerAddress,
    feeGmxTrackerAddress,
    feeGlpTrackerAddress,
  ];
  const rewardTrackersForStakingInfo = [
    stakedGmxTrackerAddress,
    bonusGmxTrackerAddress,
    feeGmxTrackerAddress,
    stakedGlpTrackerAddress,
    feeGlpTrackerAddress,
    extendedGmxTrackerAddress,
  ];

  // const { marketTokensData } = useMarketTokensData(chainId, { isDeposit: false });
  // const {
  //   marketsTokensApyData,
  //   marketsTokensIncentiveAprData,
  //   glvTokensIncentiveAprData,
  //   marketsTokensLidoAprData,
  //   glvApyInfoData,
  // } = useGmMarketsApy(chainId);
  const vestingData = useVestingData(account);
  // const govTokenAmount = useGovTokenAmount(chainId);
  // const govTokenDelegatesAddress = useGovTokenDelegates(chainId);
  // const { ensName: govTokenDelegatesEns } = useENS(govTokenDelegatesAddress);

  const { data: walletBalances, mutate: refetchBalances } = useSWR(
    [
      `StakeV2:walletBalances:${active}`,
      chainId,
      readerAddress,
      "getTokenBalancesWithSupplies",
      account || PLACEHOLDER_ACCOUNT,
    ],
    {
      fetcher: contractFetcher(signer, ReaderV2, [walletTokens]),
    }
  );

  const { data: depositBalances } = useSWR(
    [
      `StakeV2:depositBalances:${active}`,
      chainId,
      rewardReaderAddress,
      "getDepositBalances",
      account || PLACEHOLDER_ACCOUNT,
    ],
    {
      fetcher: contractFetcher(signer, RewardReader, [depositTokens, rewardTrackersForDepositBalances]),
    }
  );

  const { data: stakingInfo } = useSWR(
    [`StakeV2:stakingInfo:${active}`, chainId, rewardReaderAddress, "getStakingInfo", account || PLACEHOLDER_ACCOUNT],
    {
      fetcher: contractFetcher(signer, RewardReader, [rewardTrackersForStakingInfo]),
    }
  );

  const { data: stakedGmxSupply } = useSWR(
    [`StakeV2:stakedGmxSupply:${active}`, chainId, gmxAddress, "balanceOf", stakedGmxTrackerAddress],
    {
      fetcher: contractFetcher(signer, Token),
    }
  );

  const { data: aums } = useSWR([`StakeV2:getAums:${active}`, chainId, glpManagerAddress, "getAums"], {
    fetcher: contractFetcher(signer, GlpManager),
  });

  const { data: nativeTokenPrice } = useSWR(
    [`StakeV2:nativeTokenPrice:${active}`, chainId, vaultAddress, "getMinPrice", nativeTokenAddress],
    {
      fetcher: contractFetcher(signer, Vault),
    }
  );

  const { data: esGmxSupply } = useSWR(
    [`StakeV2:esGmxSupply:${active}`, chainId, readerAddress, "getTokenSupply", esGmxAddress],
    {
      fetcher: contractFetcher(signer, ReaderV2, [excludedEsGmxAccounts]),
    }
  );

  const { data: sbfGmxBalance } = useSWR(
    [`StakeV2:sbfGmxBalance:${active}`, chainId, feeGmxTrackerAddress, "balanceOf", account ?? PLACEHOLDER_ACCOUNT],
    {
      fetcher: contractFetcher(undefined, Token),
    }
  );

  const { gmxPrice, gmxPriceFromArbitrum, gmxPriceFromAvalanche } = useGmxPrice(
    chainId,
    { arbitrum: chainId === ARBITRUM ? signer : undefined },
    active
  );

  // let { total: totalGmxSupply } = useTotalGmxSupply();

  const stakedGMXInfo = useTotalGmxStaked();
  const { [AVALANCHE]: avaxGmxStaked, [ARBITRUM]: arbitrumGmxStaked, total: totalGmxStaked } = stakedGMXInfo;

  const gmxSupplyUrl = getServerUrl(chainId, "/gmx_supply");
  // const { data: gmxSupply } = useSWR([gmxSupplyUrl], {
  //   fetcher: (args) => fetch(...args).then((res) => res.text()),
  // });
  const gmxSupply = "0";
  const isGmxTransferEnabled = true;

  let esGmxSupplyUsd;
  if (esGmxSupply !== undefined && gmxPrice !== undefined) {
    esGmxSupplyUsd = bigMath.mulDiv(esGmxSupply, gmxPrice, expandDecimals(1, 18));
  }

  let aum;
  if (aums && aums.length > 0) {
    aum = (aums[0] + aums[1]) / 2n;
  }

  const { balanceData, supplyData } = useMemo(() => getBalanceAndSupplyData(walletBalances), [walletBalances]);
  const depositBalanceData = useMemo(() => getDepositBalanceData(depositBalances), [depositBalances]);
  const stakingData = useMemo(() => getStakingData(stakingInfo), [stakingInfo]);

  // const userTotalGmInfo = useMemo(() => {
  //   if (!active) return;
  //   return getTotalGmInfo(marketTokensData);
  // }, [marketTokensData, active]);

  const processedData = getProcessedData(
    balanceData,
    supplyData,
    depositBalanceData,
    stakingData,
    vestingData,
    aum,
    nativeTokenPrice,
    stakedGmxSupply,
    gmxPrice,
    gmxSupply
  );

  const isAnyNativeTokenRewards =
    (processedData?.totalNativeTokenRewardsUsd ?? 0n) > 10n ** BigInt(USD_DECIMALS) / 100n;
  const isAnyFeeGmxTrackerRewards = (processedData?.feeGmxTrackerRewardsUsd ?? 0n) > 10n ** BigInt(USD_DECIMALS) / 100n;

  const reservedAmount =
    (processedData?.gmxInStakedGmx !== undefined &&
      processedData?.esGmxInStakedGmx !== undefined &&
      sbfGmxBalance !== undefined &&
      processedData?.gmxInStakedGmx + processedData?.esGmxInStakedGmx - sbfGmxBalance) ||
    0n;

  let totalRewardTokens;

  if (processedData && processedData.bonusGmxInFeeGmx !== undefined) {
    totalRewardTokens = processedData.bonusGmxInFeeGmx;
  }

  let totalRewardAndLpTokens = totalRewardTokens ?? 0n;
  if (processedData?.glpBalance !== undefined) {
    totalRewardAndLpTokens = totalRewardAndLpTokens + processedData.glpBalance;
  }
  // if ((userTotalGmInfo?.balance ?? 0n) > 0) {
  //   totalRewardAndLpTokens = totalRewardAndLpTokens + (userTotalGmInfo?.balance ?? 0n);
  // }

  let stakedGmxSupplyUsd;
  if (totalGmxStaked !== 0n && gmxPrice !== undefined) {
    stakedGmxSupplyUsd = bigMath.mulDiv(totalGmxStaked, gmxPrice, expandDecimals(1, 18));
  }

  let totalSupplyUsd;
  // if (totalGmxSupply !== undefined && totalGmxSupply !== 0n && gmxPrice) {
  //   totalSupplyUsd = bigMath.mulDiv(totalGmxSupply, gmxPrice, expandDecimals(1, 18));
  // }

  const showStakeGmxModal = useCallback(() => {
    if (!isGmxTransferEnabled) {
      helperToast.error(t`TMX transfers not yet enabled`);
      return;
    }

    setIsStakeGmxModalVisible(true);
    setStakeGmxValue("");
  }, [isGmxTransferEnabled]);

  const showStakeEsGmxModal = useCallback(() => {
    setIsStakeEsGmxModalVisible(true);
    setStakeEsGmxValue("");
  }, []);

  const showGmxVesterDepositModal = () => {
    if (!vestingData) return;

    let remainingVestableAmount = vestingData.gmxVester.maxVestableAmount - vestingData.gmxVester.vestedAmount;
    if (processedData?.esGmxBalance !== undefined && processedData?.esGmxBalance < remainingVestableAmount) {
      remainingVestableAmount = processedData.esGmxBalance;
    }

    setIsVesterDepositModalVisible(true);
    setVesterDepositTitle(t`TMX Vault`);
    setVesterDepositStakeTokenLabel("staked TMX + esTMX");
    setVesterDepositMaxAmount(remainingVestableAmount);
    setVesterDepositBalance(processedData?.esGmxBalance);
    setVesterDepositVestedAmount(vestingData.gmxVester.vestedAmount);
    setVesterDepositMaxVestableAmount(vestingData.gmxVester.maxVestableAmount);
    setVesterDepositAverageStakedAmount(vestingData.gmxVester.averageStakedAmount);
    setVesterDepositReserveAmount(reservedAmount);
    setVesterDepositMaxReserveAmount(totalRewardTokens);
    setVesterDepositValue("");
    setVesterDepositAddress(gmxVesterAddress);
  };

  const showGlpVesterDepositModal = () => {
    if (!vestingData) return;

    let remainingVestableAmount = vestingData.glpVester.maxVestableAmount - vestingData.glpVester.vestedAmount;
    if (processedData?.esGmxBalance !== undefined && processedData?.esGmxBalance < remainingVestableAmount) {
      remainingVestableAmount = processedData.esGmxBalance;
    }

    setIsVesterDepositModalVisible(true);
    setVesterDepositTitle(t`TLP Vault`);
    setVesterDepositStakeTokenLabel("staked TLP");
    setVesterDepositMaxAmount(remainingVestableAmount);
    setVesterDepositBalance(processedData?.esGmxBalance);
    setVesterDepositVestedAmount(vestingData.glpVester.vestedAmount);
    setVesterDepositMaxVestableAmount(vestingData.glpVester.maxVestableAmount);
    setVesterDepositAverageStakedAmount(vestingData.glpVester.averageStakedAmount);
    setVesterDepositReserveAmount(vestingData.glpVester.pairAmount);
    setVesterDepositMaxReserveAmount(processedData?.glpBalance);
    setVesterDepositValue("");
    setVesterDepositAddress(glpVesterAddress);
  };

  const showGmxVesterWithdrawModal = () => {
    if (!vestingData || vestingData.gmxVesterVestedAmount === undefined || vestingData.gmxVesterVestedAmount === 0n) {
      helperToast.error(t`You have not deposited any tokens for vesting.`);
      return;
    }

    setIsVesterWithdrawModalVisible(true);
    setVesterWithdrawTitle(t`Withdraw from TMX Vault`);
    setVesterWithdrawAddress(gmxVesterAddress);
  };

  const showGlpVesterWithdrawModal = () => {
    if (!vestingData || vestingData.glpVesterVestedAmount === undefined || vestingData.glpVesterVestedAmount === 0n) {
      helperToast.error(t`You have not deposited any tokens for vesting.`);
      return;
    }

    setIsVesterWithdrawModalVisible(true);
    setVesterWithdrawTitle(t`Withdraw from TLP Vault`);
    setVesterWithdrawAddress(glpVesterAddress);
  };

  const showUnstakeGmxModal = () => {
    if (!isGmxTransferEnabled) {
      helperToast.error(t`TMX transfers not yet enabled`);
      return;
    }
    setIsUnstakeModalVisible(true);
    setUnstakeModalTitle(t`Unstake TMX`);
    let maxAmount = processedData?.gmxInStakedGmx;

    if (maxAmount !== undefined) {
      maxAmount = bigMath.min(maxAmount, sbfGmxBalance);
    }

    setUnstakeModalMaxAmount(maxAmount);
    setUnstakeValue("");
    setUnstakingTokenSymbol("TMX");
    setUnstakeMethodName("unstakeTmx");
  };

  const showUnstakeEsGmxModal = () => {
    setIsUnstakeModalVisible(true);
    setUnstakeModalTitle(t`Unstake esTMX`);
    let maxAmount = processedData?.esGmxInStakedGmx;

    if (maxAmount !== undefined) {
      maxAmount = bigMath.min(maxAmount, sbfGmxBalance);
    }

    setUnstakeModalMaxAmount(maxAmount);
    setUnstakeValue("");
    setUnstakingTokenSymbol("esTMX");
    setUnstakeMethodName("unstakeEsGmx");
  };

  function showAffiliateVesterDepositModal() {
    if (!vestingData?.affiliateVester) {
      helperToast.error(t`Unsupported network`);
      return;
    }

    let remainingVestableAmount =
      vestingData.affiliateVester.maxVestableAmount - vestingData.affiliateVester.vestedAmount;
    if (processedData?.esGmxBalance !== undefined && processedData.esGmxBalance < remainingVestableAmount) {
      remainingVestableAmount = processedData.esGmxBalance;
    }

    setIsVesterDepositModalVisible(true);
    setVesterDepositTitle(t`Affiliate Vault`);

    setVesterDepositMaxAmount(remainingVestableAmount);
    setVesterDepositBalance(processedData?.esGmxBalance);
    setVesterDepositVestedAmount(vestingData?.affiliateVester.vestedAmount);
    setVesterDepositMaxVestableAmount(vestingData?.affiliateVester.maxVestableAmount);
    setVesterDepositAverageStakedAmount(vestingData?.affiliateVester.averageStakedAmount);

    setVesterDepositReserveAmount(undefined);
    setVesterDepositValue("");

    setVesterDepositAddress(affiliateVesterAddress);
  }

  function showAffiliateVesterWithdrawModal() {
    if (vestingData?.affiliateVesterVestedAmount === undefined || vestingData.affiliateVesterVestedAmount <= 0) {
      helperToast.error(t`You have not deposited any tokens for vesting.`);
      return;
    }

    setIsAffiliateVesterWithdrawModalVisible(true);
  }

  function showAffiliateVesterClaimModal() {
    if (vestingData?.affiliateVesterClaimable === undefined || vestingData?.affiliateVesterClaimable <= 0) {
      helperToast.error(t`You have no TMX tokens to claim.`);
      return;
    }
    setIsAffiliateClaimModalVisible(true);
  }

  const gmxAvgAprText = useMemo(() => {
    return `${formatAmount(processedData?.gmxAprTotal, 2, 2, true)}%`;
  }, [processedData?.gmxAprTotal]);

  let earnMsg;
  if (totalRewardAndLpTokens && totalRewardAndLpTokens > 0) {
    let gmxAmountStr;
    if (processedData?.gmxInStakedGmx && processedData.gmxInStakedGmx > 0) {
      gmxAmountStr = formatAmount(processedData.gmxInStakedGmx, 18, 2, true) + " TMX";
    }
    let esGmxAmountStr;
    if (processedData?.esGmxInStakedGmx && processedData.esGmxInStakedGmx > 0) {
      esGmxAmountStr = formatAmount(processedData.esGmxInStakedGmx, 18, 2, true) + " esTMX";
    }
    let glpStr;
    if (processedData?.glpBalance && processedData.glpBalance > 0) {
      glpStr = formatAmount(processedData.glpBalance, 18, 2, true) + " TLP";
    }
    let gmStr;
    // if (userTotalGmInfo?.balance && userTotalGmInfo.balance > 0) {
    //   gmStr = formatAmount(userTotalGmInfo.balance, 18, 2, true) + " GM";
    // }
    const amountStr = [gmxAmountStr, esGmxAmountStr, gmStr, glpStr].filter((s) => s).join(", ");
    earnMsg = (
      <div>
        <Trans>
          You are earning rewards with {formatAmount(totalRewardAndLpTokens, 18, 2, true)} tokens.
          <br />
          Tokens: {amountStr}.
        </Trans>
      </div>
    );
  }

  const stakedEntries = useMemo(
    () => ({
      "Staked on Arbitrum": arbitrumGmxStaked,
      // "Staked on Avalanche": avaxGmxStaked,
    }),
    [arbitrumGmxStaked, avaxGmxStaked]
  );

  const gmxMarketAddress = useMemo(() => {
    if (chainId === ARBITRUM) {
      return Object.values(MARKETS[ARBITRUM]).find((m) => m.indexTokenAddress === gmxAddress)?.marketTokenAddress;
    }
    return undefined;
  }, [chainId, gmxAddress]);

  // const gmxMarketApyDataText = useMemo(() => {
  //   if (!gmxMarketAddress || chainId !== ARBITRUM) return;
  //
  //   const gmxApy =
  //     (marketsTokensApyData?.[gmxMarketAddress] ?? 0n) + (marketsTokensIncentiveAprData?.[gmxMarketAddress] ?? 0n);
  //
  //   return `${formatAmount(gmxApy, 28, 2, true)}%`;
  // }, [marketsTokensApyData, marketsTokensIncentiveAprData, gmxMarketAddress, chainId]);

  const hideToasts = useCallback(() => toast.dismiss(), []);
  const handleStakeGmx = useCallback(async () => {
    hideToasts();
    showStakeGmxModal();
  }, [showStakeGmxModal, hideToasts]);

  return (
    <SEO title={getPageTitle(t`Earn`)}>
      <div className="default-container page-layout">
        {/*<StakeModal*/}
        {/*  isVisible={isStakeGmxModalVisible}*/}
        {/*  setIsVisible={setIsStakeGmxModalVisible}*/}
        {/*  chainId={chainId}*/}
        {/*  title={t`Stake TMX`}*/}
        {/*  maxAmount={processedData?.gmxBalance}*/}
        {/*  value={stakeGmxValue}*/}
        {/*  setValue={setStakeGmxValue}*/}
        {/*  signer={signer}*/}
        {/*  stakingTokenSymbol="TMX"*/}
        {/*  stakingTokenAddress={gmxAddress}*/}
        {/*  farmAddress={stakedGmxTrackerAddress}*/}
        {/*  rewardRouterAddress={rewardRouterAddress}*/}
        {/*  stakeMethodName="stakeGmx"*/}
        {/*  setPendingTxns={setPendingTxns}*/}
        {/*  processedData={processedData}*/}
        {/*/>*/}
        {/*<StakeModal*/}
        {/*  isVisible={isStakeEsGmxModalVisible}*/}
        {/*  setIsVisible={setIsStakeEsGmxModalVisible}*/}
        {/*  chainId={chainId}*/}
        {/*  title={t`Stake esTMX`}*/}
        {/*  maxAmount={processedData?.esGmxBalance}*/}
        {/*  value={stakeEsGmxValue}*/}
        {/*  setValue={setStakeEsGmxValue}*/}
        {/*  signer={signer}*/}
        {/*  stakingTokenSymbol="esGMX"*/}
        {/*  stakingTokenAddress={esGmxAddress}*/}
        {/*  farmAddress={ZeroAddress}*/}
        {/*  rewardRouterAddress={rewardRouterAddress}*/}
        {/*  stakeMethodName="stakeEsGmx"*/}
        {/*  setPendingTxns={setPendingTxns}*/}
        {/*  processedData={processedData}*/}
        {/*/>*/}
        {/*<UnstakeModal*/}
        {/*  setPendingTxns={setPendingTxns}*/}
        {/*  isVisible={isUnstakeModalVisible}*/}
        {/*  setIsVisible={setIsUnstakeModalVisible}*/}
        {/*  chainId={chainId}*/}
        {/*  title={unstakeModalTitle}*/}
        {/*  maxAmount={unstakeModalMaxAmount}*/}
        {/*  reservedAmount={reservedAmount}*/}
        {/*  value={unstakeValue}*/}
        {/*  setValue={setUnstakeValue}*/}
        {/*  signer={signer}*/}
        {/*  unstakingTokenSymbol={unstakingTokenSymbol}*/}
        {/*  rewardRouterAddress={rewardRouterAddress}*/}
        {/*  unstakeMethodName={unstakeMethodName}*/}
        {/*  processedData={processedData}*/}
        {/*/>*/}
        {/*<VesterDepositModal*/}
        {/*  isVisible={isVesterDepositModalVisible}*/}
        {/*  setIsVisible={setIsVesterDepositModalVisible}*/}
        {/*  chainId={chainId}*/}
        {/*  title={vesterDepositTitle}*/}
        {/*  stakeTokenLabel={vesterDepositStakeTokenLabel}*/}
        {/*  maxAmount={vesterDepositMaxAmount}*/}
        {/*  balance={vesterDepositBalance}*/}
        {/*  vestedAmount={vesterDepositVestedAmount}*/}
        {/*  averageStakedAmount={*/}
        {/*    typeof vesterDepositAverageStakedAmount === "string"*/}
        {/*      ? vesterDepositAverageStakedAmount === ""*/}
        {/*        ? undefined*/}
        {/*        : BigInt(vesterDepositAverageStakedAmount)*/}
        {/*      : vesterDepositAverageStakedAmount*/}
        {/*  }*/}
        {/*  maxVestableAmount={vesterDepositMaxVestableAmount}*/}
        {/*  reserveAmount={vesterDepositReserveAmount}*/}
        {/*  maxReserveAmount={vesterDepositMaxReserveAmount}*/}
        {/*  value={vesterDepositValue}*/}
        {/*  setValue={setVesterDepositValue}*/}
        {/*  signer={signer}*/}
        {/*  vesterAddress={vesterDepositAddress}*/}
        {/*  setPendingTxns={setPendingTxns}*/}
        {/*/>*/}
        {/*<VesterWithdrawModal*/}
        {/*  isVisible={isVesterWithdrawModalVisible}*/}
        {/*  setIsVisible={setIsVesterWithdrawModalVisible}*/}
        {/*  vesterAddress={vesterWithdrawAddress}*/}
        {/*  chainId={chainId}*/}
        {/*  title={vesterWithdrawTitle}*/}
        {/*  signer={signer}*/}
        {/*  setPendingTxns={setPendingTxns}*/}
        {/*/>*/}
        {/*<AffiliateVesterWithdrawModal*/}
        {/*  isVisible={isAffiliateVesterWithdrawModalVisible}*/}
        {/*  setIsVisible={setIsAffiliateVesterWithdrawModalVisible}*/}
        {/*  chainId={chainId}*/}
        {/*  signer={signer}*/}
        {/*  setPendingTxns={setPendingTxns}*/}
        {/*/>*/}
        {/*<ClaimModal*/}
        {/*  setPendingTxns={setPendingTxns}*/}
        {/*  isVisible={isCompoundModalVisible}*/}
        {/*  setIsVisible={setIsCompoundModalVisible}*/}
        {/*  rewardRouterAddress={rewardRouterAddress}*/}
        {/*  totalGmxRewards={processedData?.totalGmxRewards}*/}
        {/*  wrappedTokenSymbol={wrappedTokenSymbol}*/}
        {/*  nativeTokenSymbol={nativeTokenSymbol}*/}
        {/*  signer={signer}*/}
        {/*  chainId={chainId}*/}
        {/*  isNativeTokenToClaim={isAnyNativeTokenRewards}*/}
        {/*  onClaimSuccess={refetchBalances}*/}
        {/*  gmxUsageOptionsMsg={*/}
        {/*    <ul className="list-disc">*/}
        {/*      <li className="!pb-0">*/}
        {/*        <Trans>*/}
        {/*          <Link className="link-underline" to="#" onClick={handleStakeGmx}>*/}
        {/*            Stake TMX*/}
        {/*          </Link>{" "}*/}
        {/*          and earn {gmxAvgAprText} APR*/}
        {/*        </Trans>*/}
        {/*      </li>*/}
        {/*      {chainId === ARBITRUM && (*/}
        {/*        <>*/}
        {/*          <li className="!pb-0">*/}
        {/*            <Trans>*/}
        {/*              <Link*/}
        {/*                className="link-underline"*/}
        {/*                to={`/pools/?market=${gmxMarketAddress}&operation=buy&scroll=1`}*/}
        {/*                onClick={hideToasts}*/}
        {/*              >*/}
        {/*                Provide liquidity*/}
        {/*              </Link>{" "}*/}
        {/*              and earn {gmxMarketApyDataText} APY*/}
        {/*            </Trans>*/}
        {/*          </li>*/}
        {/*          <li className="!pb-0">*/}
        {/*            <Trans>*/}
        {/*              <Link*/}
        {/*                className="link-underline"*/}
        {/*                to={`/trade/long/?mode=market&from=gmx&market=gmx`}*/}
        {/*                onClick={hideToasts}*/}
        {/*              >*/}
        {/*                Trade TMX*/}
        {/*              </Link>*/}
        {/*            </Trans>*/}
        {/*          </li>*/}
        {/*        </>*/}
        {/*      )}*/}
        {/*    </ul>*/}
        {/*  }*/}
        {/*/>*/}
        {/*<AffiliateClaimModal*/}
        {/*  signer={signer}*/}
        {/*  chainId={chainId}*/}
        {/*  setPendingTxns={setPendingTxns}*/}
        {/*  isVisible={isAffiliateClaimModalVisible}*/}
        {/*  setIsVisible={setIsAffiliateClaimModalVisible}*/}
        {/*  totalVesterRewards={vestingData?.affiliateVesterClaimable ?? BN_ZERO}*/}
        {/*/>*/}

        <PageTitle
          isTop
          title={t`Earn`}
          qa="earn-page"
          subtitle={
            <div>
              <Trans>
                Buy TLP to earn rewards.
                {/*Stake <ExternalLink href="https://docs.gmx.io/docs/tokenomics/gmx-token">TMX</ExternalLink> and buy{" "}*/}
                {/*<ExternalLink href="https://docs.gmx.io/docs/providing-liquidity/v2">GM</ExternalLink> or{" "}*/}
                {/*<ExternalLink href="https://docs.gmx.io/docs/providing-liquidity/v1">TLP</ExternalLink> to earn rewards.*/}
              </Trans>
              {earnMsg && <div className="Page-descriptionж">{earnMsg}</div>}
              {/*{incentivesMessage}*/}
            </div>
            // <div>
            //   <Trans>
            //     Stake <ExternalLink href="#">TMX</ExternalLink> and buy <ExternalLink href="#">GM</ExternalLink> or{" "}
            //     <ExternalLink href="#">TLP</ExternalLink> to earn rewards.
            //     {/*Stake <ExternalLink href="https://docs.gmx.io/docs/tokenomics/gmx-token">TMX</ExternalLink> and buy{" "}*/}
            //     {/*<ExternalLink href="https://docs.gmx.io/docs/providing-liquidity/v2">GM</ExternalLink> or{" "}*/}
            //     {/*<ExternalLink href="https://docs.gmx.io/docs/providing-liquidity/v1">TLP</ExternalLink> to earn rewards.*/}
            //   </Trans>
            //   {earnMsg && <div className="Page-descriptionж">{earnMsg}</div>}
            //   {incentivesMessage}
            // </div>
          }
        />
        <div className="StakeV2-content">
          <div className="StakeV2-cards">
            {/*<div className="App-card StakeV2-gmx-card">*/}
            {/*  <div className="App-card-title">*/}
            {/*    <div className="inline-flex items-center">*/}
            {/*      <img className="mr-5 h-20" alt="TMX" src={icons?.gmx} height={20} />*/}
            {/*      {t`TMX & Voting Power`}*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*  <div className="App-card-divider"></div>*/}
            {/*  <div className="App-card-content">*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Price</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        {!gmxPrice && "..."}*/}
            {/*        {gmxPrice && (*/}
            {/*          <Tooltip*/}
            {/*            position="bottom-end"*/}
            {/*            className="whitespace-nowrap"*/}
            {/*            handle={"$" + formatAmount(gmxPrice, USD_DECIMALS, 2, true)}*/}
            {/*            renderContent={() => (*/}
            {/*              <>*/}
            {/*                <StatsTooltipRow*/}
            {/*                  label={t`Price on Avalanche`}*/}
            {/*                  value={formatAmount(gmxPriceFromAvalanche, USD_DECIMALS, 2, true)}*/}
            {/*                />*/}
            {/*                <StatsTooltipRow*/}
            {/*                  label={t`Price on Arbitrum`}*/}
            {/*                  value={formatAmount(gmxPriceFromArbitrum, USD_DECIMALS, 2, true)}*/}
            {/*                />*/}
            {/*              </>*/}
            {/*            )}*/}
            {/*          />*/}
            {/*        )}*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Wallet</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        {formatKeyAmount(processedData, "gmxBalance", 18, 2, true)} TMX ($*/}
            {/*        {formatKeyAmount(processedData, "gmxBalanceUsd", USD_DECIMALS, 2, true)})*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Staked</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        {formatKeyAmount(processedData, "gmxInStakedGmx", 18, 2, true)} TMX ($*/}
            {/*        {formatKeyAmount(processedData, "gmxInStakedGmxUsd", USD_DECIMALS, 2, true)})*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    {chainId === ARBITRUM && (*/}
            {/*      <div className="App-card-row">*/}
            {/*        <div className="label">*/}
            {/*          <Trans>Voting Power</Trans>*/}
            {/*        </div>*/}
            {/*        <div>*/}
            {/*          {govTokenAmount !== undefined ? (*/}
            {/*            <Tooltip*/}
            {/*              position="bottom-end"*/}
            {/*              className="nowrap"*/}
            {/*              handle={`${formatAmount(govTokenAmount, 18, 2, true)} TMX DAO`}*/}
            {/*              renderContent={() => (*/}
            {/*                <>*/}
            {/*                  {govTokenDelegatesAddress === NATIVE_TOKEN_ADDRESS && govTokenAmount > 0 ? (*/}
            {/*                    <AlertInfo*/}
            {/*                      type="warning"*/}
            {/*                      className={cx("DelegateGMXAlertInfo")}*/}
            {/*                      textColor="text-yellow-500"*/}
            {/*                    >*/}
            {/*                      <Trans>*/}
            {/*                        <ExternalLink href={GMX_DAO_LINKS.VOTING_POWER} className="display-inline">*/}
            {/*                          Delegate your undelegated {formatAmount(govTokenAmount, 18, 2, true)} TMX DAO*/}
            {/*                        </ExternalLink>{" "}*/}
            {/*                        voting power.*/}
            {/*                      </Trans>*/}
            {/*                    </AlertInfo>*/}
            {/*                  ) : null}*/}
            {/*                  <StatsTooltipRow*/}
            {/*                    label={t`Delegated to`}*/}
            {/*                    value={*/}
            {/*                      !govTokenDelegatesAddress || govTokenDelegatesAddress === NATIVE_TOKEN_ADDRESS ? (*/}
            {/*                        <Trans>No delegate found</Trans>*/}
            {/*                      ) : (*/}
            {/*                        <ExternalLink href={"#"}>*/}
            {/*                          /!*<ExternalLink href={getGmxDAODelegateLink(govTokenDelegatesAddress)}>*!/*/}
            {/*                          {govTokenDelegatesAddress === account*/}
            {/*                            ? t`Myself`*/}
            {/*                            : govTokenDelegatesEns*/}
            {/*                              ? shortenAddressOrEns(govTokenDelegatesEns, 25)*/}
            {/*                              : shortenAddressOrEns(govTokenDelegatesAddress, 13)}*/}
            {/*                        </ExternalLink>*/}
            {/*                      )*/}
            {/*                    }*/}
            {/*                    showDollar={false}*/}
            {/*                  />*/}
            {/*                  <br />*/}
            {/*                  <ExternalLink href={GMX_DAO_LINKS.DELEGATES}>Explore the list of delegates</ExternalLink>.*/}
            {/*                </>*/}
            {/*              )}*/}
            {/*            />*/}
            {/*          ) : (*/}
            {/*            "..."*/}
            {/*          )}*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    )}*/}
            {/*    <div className="App-card-divider"></div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>APR</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        <Tooltip*/}
            {/*          handle={gmxAvgAprText}*/}
            {/*          position="bottom-end"*/}
            {/*          renderContent={() => (*/}
            {/*            <GMXAprTooltip processedData={processedData} nativeTokenSymbol={nativeTokenSymbol} />*/}
            {/*          )}*/}
            {/*        />*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Rewards</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        <Tooltip*/}
            {/*          handle={`$${formatKeyAmount(processedData, "totalStakingRewardsUsd", USD_DECIMALS, 2, true)}`}*/}
            {/*          position="bottom-end"*/}
            {/*          renderContent={() => {*/}
            {/*            return (*/}
            {/*              <>*/}
            {/*                <StatsTooltipRow*/}
            {/*                  label={t`TMX`}*/}
            {/*                  value={`${formatKeyAmount(*/}
            {/*                    processedData,*/}
            {/*                    "extendedGmxTrackerRewards",*/}
            {/*                    18,*/}
            {/*                    4*/}
            {/*                  )} ($${formatKeyAmount(processedData, "extendedGmxTrackerRewardsUsd", USD_DECIMALS, 2, true)})`}*/}
            {/*                  showDollar={false}*/}
            {/*                />*/}
            {/*                <StatsTooltipRow*/}
            {/*                  label="Escrowed TMX"*/}
            {/*                  value={`${formatKeyAmount(*/}
            {/*                    processedData,*/}
            {/*                    "stakedGmxTrackerRewards",*/}
            {/*                    18,*/}
            {/*                    4*/}
            {/*                  )} ($${formatKeyAmount(*/}
            {/*                    processedData,*/}
            {/*                    "stakedGmxTrackerRewardsUsd",*/}
            {/*                    USD_DECIMALS,*/}
            {/*                    2,*/}
            {/*                    true*/}
            {/*                  )})`}*/}
            {/*                  showDollar={false}*/}
            {/*                />*/}
            {/*                {isAnyFeeGmxTrackerRewards && (*/}
            {/*                  <StatsTooltipRow*/}
            {/*                    label={`${nativeTokenSymbol} (${wrappedTokenSymbol})`}*/}
            {/*                    value={`${formatKeyAmount(*/}
            {/*                      processedData,*/}
            {/*                      "feeGmxTrackerRewards",*/}
            {/*                      18,*/}
            {/*                      4*/}
            {/*                    )} ($${formatKeyAmount(processedData, "feeGmxTrackerRewardsUsd", USD_DECIMALS, 2, true)})`}*/}
            {/*                    showDollar={false}*/}
            {/*                  />*/}
            {/*                )}*/}
            {/*              </>*/}
            {/*            );*/}
            {/*          }}*/}
            {/*        />*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-divider"></div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Total Staked</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        {totalGmxStaked === undefined && "..."}*/}
            {/*        {(totalGmxStaked !== undefined && (*/}
            {/*          <Tooltip*/}
            {/*            position="bottom-end"*/}
            {/*            className="whitespace-nowrap"*/}
            {/*            handle={*/}
            {/*              formatAmount(totalGmxStaked, 18, 0, true) +*/}
            {/*              " TMX" +*/}
            {/*              ` ($${formatAmount(stakedGmxSupplyUsd, USD_DECIMALS, 0, true)})`*/}
            {/*            }*/}
            {/*            renderContent={() => (*/}
            {/*              <ChainsStatsTooltipRow*/}
            {/*                showDollar={false}*/}
            {/*                decimalsForConversion={18}*/}
            {/*                symbol="GMX"*/}
            {/*                entries={stakedEntries}*/}
            {/*              />*/}
            {/*            )}*/}
            {/*          />*/}
            {/*        )) ||*/}
            {/*          null}*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Total Supply</Trans>*/}
            {/*      </div>*/}
            {/*      {totalGmxSupply === undefined && "..."}*/}
            {/*      {(totalGmxSupply !== undefined && (*/}
            {/*        <div>*/}
            {/*          {formatAmount(totalGmxSupply, 18, 0, true)} TMX ($*/}
            {/*          {formatAmount(totalSupplyUsd, USD_DECIMALS, 0, true)})*/}
            {/*        </div>*/}
            {/*      )) ||*/}
            {/*        null}*/}
            {/*    </div>*/}
            {/*    <div className="App-card-divider" />*/}
            {/*    <div className="App-card-buttons m-0">*/}
            {/*      <Button variant="secondary" to="/buy_tmx">*/}
            {/*        <Trans>Buy TMX</Trans>*/}
            {/*      </Button>*/}
            {/*      {active && (*/}
            {/*        <Button variant="secondary" onClick={() => showStakeGmxModal()}>*/}
            {/*          <Trans>Stake</Trans>*/}
            {/*        </Button>*/}
            {/*      )}*/}
            {/*      {active && (*/}
            {/*        <Button variant="secondary" onClick={() => showUnstakeGmxModal()}>*/}
            {/*          <Trans>Unstake</Trans>*/}
            {/*        </Button>*/}
            {/*      )}*/}
            {/*      {active && chainId === ARBITRUM && (*/}
            {/*        <Button variant="secondary" to={GMX_DAO_LINKS.VOTING_POWER} newTab>*/}
            {/*          <Trans>Delegate</Trans>*/}
            {/*        </Button>*/}
            {/*      )}*/}
            {/*      {active && (*/}
            {/*        <Button variant="secondary" to="/begin_account_transfer">*/}
            {/*          <Trans>Transfer Account</Trans>*/}
            {/*        </Button>*/}
            {/*      )}*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*<div className="App-card primary StakeV2-total-rewards-card">*/}
            {/*  <div className="App-card-title">*/}
            {/*    <Trans>Total Rewards</Trans>*/}
            {/*  </div>*/}
            {/*  <div className="App-card-divider"></div>*/}
            {/*  <div className="App-card-content">*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">TMX</div>*/}
            {/*      <Tooltip*/}
            {/*        handle={*/}
            {/*          <div>*/}
            {/*            {formatKeyAmount(processedData, "totalGmxRewards", 18, 4, true)} ($*/}
            {/*            {formatKeyAmount(processedData, "totalGmxRewardsUsd", USD_DECIMALS, 2, true)})*/}
            {/*          </div>*/}
            {/*        }*/}
            {/*        position="bottom-end"*/}
            {/*        content={*/}
            {/*          <>*/}
            {/*            <StatsTooltipRow*/}
            {/*              label={*/}
            {/*                <>*/}
            {/*                  {t`TMX Staked Rewards`}:*/}
            {/*                  <div className="mx-4 inline" />*/}
            {/*                </>*/}
            {/*              }*/}
            {/*              showDollar={false}*/}
            {/*              value={*/}
            {/*                <>*/}
            {/*                  {formatKeyAmount(processedData, "extendedGmxTrackerRewards", 18, 4, true)} ($*/}
            {/*                  {formatKeyAmount(processedData, "extendedGmxTrackerRewardsUsd", USD_DECIMALS, 2, true)})*/}
            {/*                </>*/}
            {/*              }*/}
            {/*            />*/}
            {/*            <StatsTooltipRow*/}
            {/*              label={*/}
            {/*                <>*/}
            {/*                  {t`Vested Claimable TMX`}:*/}
            {/*                  <div className="mx-4 inline" />*/}
            {/*                </>*/}
            {/*              }*/}
            {/*              showDollar={false}*/}
            {/*              value={*/}
            {/*                <>*/}
            {/*                  {formatKeyAmount(processedData, "totalVesterRewards", 18, 4, true)} ($*/}
            {/*                  {formatKeyAmount(processedData, "totalVesterRewardsUsd", USD_DECIMALS, 2, true)})*/}
            {/*                </>*/}
            {/*              }*/}
            {/*            />*/}
            {/*          </>*/}
            {/*        }*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Escrowed TMX</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        {formatKeyAmount(processedData, "totalEsGmxRewards", 18, 4, true)} ($*/}
            {/*        {formatKeyAmount(processedData, "totalEsGmxRewardsUsd", USD_DECIMALS, 2, true)})*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    {isAnyNativeTokenRewards ? (*/}
            {/*      <div className="App-card-row">*/}
            {/*        <div className="label">*/}
            {/*          {nativeTokenSymbol} ({wrappedTokenSymbol})*/}
            {/*        </div>*/}
            {/*        <div>*/}
            {/*          {formatKeyAmount(processedData, "totalNativeTokenRewards", 18, 4, true)} ($*/}
            {/*          {formatKeyAmount(processedData, "totalNativeTokenRewardsUsd", USD_DECIMALS, 2, true)})*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    ) : null}*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Total</Trans>*/}
            {/*      </div>*/}
            {/*      <div>${formatKeyAmount(processedData, "totalRewardsUsd", USD_DECIMALS, 2, true)}</div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-footer">*/}
            {/*      <div className="App-card-divider"></div>*/}
            {/*      <div className="App-card-buttons m-0">*/}
            {/*        {active && (*/}
            {/*          <Button variant="secondary" onClick={() => setIsCompoundModalVisible(true)}>*/}
            {/*            <Trans>Claim</Trans>*/}
            {/*          </Button>*/}
            {/*        )}*/}
            {/*        {!active && (*/}
            {/*          <Button variant="secondary" onClick={openConnectModal}>*/}
            {/*            <Trans>Connect Wallet</Trans>*/}
            {/*          </Button>*/}
            {/*        )}*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className="App-card App-card-space-between">
              <div>
                <div className="App-card-title">
                  <div className="inline-flex items-center">
                    <img className="mr-5 h-20" alt="TLP" src={icons?.tlp} height={20} />
                    TLP
                  </div>
                </div>
                <div className="App-card-divider"></div>
                <div className="App-card-content">
                  <div className="App-card-row">
                    <div className="label">
                      <Trans>Price</Trans>
                    </div>
                    <div>${formatKeyAmount(processedData, "glpPrice", USD_DECIMALS, GLP_PRICE_DECIMALS, true)}</div>
                  </div>
                  <div className="App-card-row">
                    <div className="label">
                      <Trans>Wallet</Trans>
                    </div>
                    <div>
                      {formatKeyAmount(processedData, "glpBalance", GLP_DECIMALS, 2, true)} TLP ($
                      {formatKeyAmount(processedData, "glpBalanceUsd", USD_DECIMALS, 2, true)})
                    </div>
                  </div>
                  <div className="App-card-row">
                    <div className="label">
                      <Trans>Staked</Trans>
                    </div>
                    <div>
                      {formatKeyAmount(processedData, "glpBalance", GLP_DECIMALS, 2, true)} TLP ($
                      {formatKeyAmount(processedData, "glpBalanceUsd", USD_DECIMALS, 2, true)})
                    </div>
                  </div>
                  <div className="App-card-divider"></div>
                  <div className="App-card-row">
                    <div className="label">
                      <Trans>APR</Trans>
                    </div>
                    <div>
                      <Tooltip
                        handle={`${formatKeyAmount(processedData, "glpAprTotal", 2, 2, true)}%`}
                        position="bottom-end"
                        renderContent={() => {
                          return (
                            <>
                              <StatsTooltipRow
                                label={`${nativeTokenSymbol} (${wrappedTokenSymbol}) APR`}
                                value={`${formatKeyAmount(processedData, "glpAprForNativeToken", 2, 2, true)}%`}
                                showDollar={false}
                              />

                              {processedData?.glpAprForEsGmx && processedData.glpAprForEsGmx > 0 && (
                                <StatsTooltipRow
                                  label="Escrowed TMX APR"
                                  value={`${formatKeyAmount(processedData, "glpAprForEsGmx", 2, 2, true)}%`}
                                  showDollar={false}
                                />
                              )}

                              <br />

                              <Trans>
                                APRs are updated weekly on Wednesday and will depend on the fees collected for the week.{" "}
                                <br />
                                <br />
                                Historical TLP APRs can be checked in this{" "}
                                <ExternalLink href="#">
                                  {/*<ExternalLink href="https://dune.com/saulius/gmx-analytics">*/}
                                  community dashboard
                                </ExternalLink>
                                .
                              </Trans>
                            </>
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="App-card-row">
                    <div className="label">
                      <Trans>Rewards</Trans>
                    </div>
                    <div>
                      <Tooltip
                        handle={`$${formatKeyAmount(processedData, "totalGlpRewardsUsd", USD_DECIMALS, 2, true)}`}
                        position="bottom-end"
                        renderContent={() => {
                          return (
                            <>
                              <StatsTooltipRow
                                label={`${nativeTokenSymbol} (${wrappedTokenSymbol})`}
                                value={`${formatKeyAmount(
                                  processedData,
                                  "feeGlpTrackerRewards",
                                  18,
                                  4
                                )} ($${formatKeyAmount(
                                  processedData,
                                  "feeGlpTrackerRewardsUsd",
                                  USD_DECIMALS,
                                  2,
                                  true
                                )})`}
                                showDollar={false}
                              />
                              <StatsTooltipRow
                                label="Escrowed TMX"
                                value={`${formatKeyAmount(
                                  processedData,
                                  "stakedGlpTrackerRewards",
                                  18,
                                  4
                                )} ($${formatKeyAmount(
                                  processedData,
                                  "stakedGlpTrackerRewardsUsd",
                                  USD_DECIMALS,
                                  2,
                                  true
                                )})`}
                                showDollar={false}
                              />
                            </>
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="App-card-divider" />
                  <div className="App-card-row">
                    <div className="label">
                      <Trans>Total Staked</Trans>
                    </div>
                    <div>
                      {formatKeyAmount(processedData, "glpSupply", 18, 2, true)} TLP ($
                      {formatKeyAmount(processedData, "glpSupplyUsd", USD_DECIMALS, 2, true)})
                    </div>
                  </div>
                  <div className="App-card-row">
                    <div className="label">
                      <Trans>Total Supply</Trans>
                    </div>
                    <div>
                      {formatKeyAmount(processedData, "glpSupply", 18, 2, true)} TLP ($
                      {formatKeyAmount(processedData, "glpSupplyUsd", USD_DECIMALS, 2, true)})
                    </div>
                  </div>

                  <div />
                </div>
              </div>
              <div>
                <div className="App-card-divider" />
                <div className="App-card-buttons glp-buttons m-0">
                  <Button variant="secondary" to="/buy_tlp">
                    <Trans>Buy TLP</Trans>
                  </Button>
                  <Button variant="secondary" to="/buy_tlp#redeem">
                    <Trans>Sell TLP</Trans>
                  </Button>
                  {hasInsurance && (
                    <Button
                      variant="secondary"
                      to="https://app.insurace.io/Insurance/Cart?id=124&referrer=545066382753150189457177837072918687520318754040"
                    >
                      <Trans>Purchase Insurance</Trans>
                    </Button>
                  )}
                </div>
              </div>
            </div>
            {/*<div className="App-card">*/}
            {/*  <div className="App-card-title">*/}
            {/*    <div className="inline-flex items-center">*/}
            {/*      <img className="mr-5 h-20" alt="TLP" src={icons?.esgmx} height={20} />*/}
            {/*      <span>*/}
            {/*        <Trans>Escrowed TMX</Trans>*/}
            {/*      </span>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*  <div className="App-card-divider"></div>*/}
            {/*  <div className="App-card-content">*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Price</Trans>*/}
            {/*      </div>*/}
            {/*      <div>${formatAmount(gmxPrice, USD_DECIMALS, 2, true)}</div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Wallet</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        {formatKeyAmount(processedData, "esGmxBalance", 18, 2, true)} esTMX ($*/}
            {/*        {formatKeyAmount(processedData, "esGmxBalanceUsd", USD_DECIMALS, 2, true)})*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Staked</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        {formatKeyAmount(processedData, "esGmxInStakedGmx", 18, 2, true)} esTMX ($*/}
            {/*        {formatKeyAmount(processedData, "esGmxInStakedGmxUsd", USD_DECIMALS, 2, true)})*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-divider"></div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>APR</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        <Tooltip*/}
            {/*          handle={gmxAvgAprText}*/}
            {/*          position="bottom-end"*/}
            {/*          renderContent={() => (*/}
            {/*            <GMXAprTooltip processedData={processedData!} nativeTokenSymbol={nativeTokenSymbol} />*/}
            {/*          )}*/}
            {/*        />*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-divider"></div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Total Staked</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        {formatKeyAmount(processedData, "stakedEsGmxSupply", 18, 0, true)} esTMX ($*/}
            {/*        {formatKeyAmount(processedData, "stakedEsGmxSupplyUsd", USD_DECIMALS, 0, true)})*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-row">*/}
            {/*      <div className="label">*/}
            {/*        <Trans>Total Supply</Trans>*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        {formatAmount(esGmxSupply, 18, 0, true)} esTMX (${formatAmount(esGmxSupplyUsd, USD_DECIMALS, 0, true)}*/}
            {/*        )*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <div className="App-card-footer">*/}
            {/*      <div className="App-card-divider"></div>*/}
            {/*      <div className="App-card-buttons m-0">*/}
            {/*        <br />*/}
            {/*        {active && (*/}
            {/*          <Button variant="secondary" onClick={() => showStakeEsGmxModal()}>*/}
            {/*            <Trans>Stake</Trans>*/}
            {/*          </Button>*/}
            {/*        )}*/}
            {/*        {active && (*/}
            {/*          <Button variant="secondary" onClick={() => showUnstakeEsGmxModal()}>*/}
            {/*            <Trans>Unstake</Trans>*/}
            {/*          </Button>*/}
            {/*        )}*/}
            {/*        {!active && (*/}
            {/*          <Button variant="secondary" onClick={openConnectModal}>*/}
            {/*            <Trans> Connect Wallet</Trans>*/}
            {/*          </Button>*/}
            {/*        )}*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>
        </div>

        {/*{getIsSyntheticsSupported(chainId) && (*/}
        {/*  <div className="StakeV2-section">*/}
        {/*    <GmList*/}
        {/*      marketsTokensApyData={marketsTokensApyData}*/}
        {/*      marketsTokensIncentiveAprData={marketsTokensIncentiveAprData}*/}
        {/*      glvTokensIncentiveAprData={glvTokensIncentiveAprData}*/}
        {/*      marketsTokensLidoAprData={marketsTokensLidoAprData}*/}
        {/*      glvTokensApyData={glvApyInfoData}*/}
        {/*      isDeposit={false}*/}
        {/*      shouldScrollToTop*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*)}*/}

        {/*<div>*/}
        {/*  <PageTitle*/}
        {/*    title={t`Vest`}*/}
        {/*    subtitle={*/}
        {/*      <Trans>*/}
        {/*        Convert esTMX tokens to TMX tokens.*/}
        {/*        <br />*/}
        {/*        Please read the{" "}*/}
        {/*        <ExternalLink href="#">*/}
        {/*          /!*<ExternalLink href="https://docs.gmx.io/docs/tokenomics/rewards#vesting">*!/*/}
        {/*          vesting details*/}
        {/*        </ExternalLink>{" "}*/}
        {/*        before using the vaults.*/}
        {/*      </Trans>*/}
        {/*    }*/}
        {/*  />*/}
        {/*  <div>*/}
        {/*    <div className="StakeV2-cards">*/}
        {/*      <div className="App-card StakeV2-gmx-card">*/}
        {/*        <div className="App-card-title">*/}
        {/*          <div className="inline-flex items-center">*/}
        {/*            <img className="mr-5 h-20" alt="TMX" src={icons?.gmx} height={20} />*/}
        {/*            <Trans>TMX Vault</Trans>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*        <div className="App-card-divider"></div>*/}
        {/*        <div className="App-card-content">*/}
        {/*          <div className="App-card-row">*/}
        {/*            <div className="label">*/}
        {/*              <Trans>Staked Tokens</Trans>*/}
        {/*            </div>*/}
        {/*            <div>*/}
        {/*              <Tooltip*/}
        {/*                handle={formatAmount(totalRewardTokens, 18, 2, true)}*/}
        {/*                position="bottom-end"*/}
        {/*                renderContent={() => {*/}
        {/*                  return (*/}
        {/*                    <>*/}
        {/*                      <StatsTooltipRow*/}
        {/*                        showDollar={false}*/}
        {/*                        label="TMX"*/}
        {/*                        value={formatAmount(processedData?.gmxInStakedGmx, 18, 2, true)}*/}
        {/*                      />*/}

        {/*                      <StatsTooltipRow*/}
        {/*                        showDollar={false}*/}
        {/*                        label="esTMX"*/}
        {/*                        value={formatAmount(processedData?.esGmxInStakedGmx, 18, 2, true)}*/}
        {/*                      />*/}
        {/*                    </>*/}
        {/*                  );*/}
        {/*                }}*/}
        {/*              />*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*          <div className="App-card-row">*/}
        {/*            <div className="label">*/}
        {/*              <Trans>Reserved for Vesting</Trans>*/}
        {/*            </div>*/}
        {/*            <div>*/}
        {/*              {formatAmount(reservedAmount, 18, 2, true)} / {formatAmount(totalRewardTokens, 18, 2, true)}*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*          <div className="App-card-row">*/}
        {/*            <div className="label">*/}
        {/*              <Trans>Vesting Status</Trans>*/}
        {/*            </div>*/}
        {/*            <div>*/}
        {/*              <Tooltip*/}
        {/*                handle={`${formatKeyAmount(vestingData, "gmxVesterClaimSum", 18, 4, true)} / ${formatKeyAmount(*/}
        {/*                  vestingData,*/}
        {/*                  "gmxVesterVestedAmount",*/}
        {/*                  18,*/}
        {/*                  4,*/}
        {/*                  true*/}
        {/*                )}`}*/}
        {/*                position="bottom-end"*/}
        {/*                renderContent={() => {*/}
        {/*                  return (*/}
        {/*                    <div>*/}
        {/*                      <Trans>*/}
        {/*                        {formatKeyAmount(vestingData, "gmxVesterClaimSum", 18, 4, true)} tokens have been*/}
        {/*                        converted to TMX from the{" "}*/}
        {/*                        {formatKeyAmount(vestingData, "gmxVesterVestedAmount", 18, 4, true)} esTMX deposited for*/}
        {/*                        vesting.*/}
        {/*                      </Trans>*/}
        {/*                    </div>*/}
        {/*                  );*/}
        {/*                }}*/}
        {/*              />*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*          <div className="App-card-row">*/}
        {/*            <div className="label">*/}
        {/*              <Trans>Claimable</Trans>*/}
        {/*            </div>*/}
        {/*            <div>*/}
        {/*              <Tooltip*/}
        {/*                handle={`${formatKeyAmount(vestingData, "gmxVesterClaimable", 18, 4, true)} TMX`}*/}
        {/*                position="bottom-end"*/}
        {/*                renderContent={() => (*/}
        {/*                  <Trans>*/}
        {/*                    {formatKeyAmount(vestingData, "gmxVesterClaimable", 18, 4, true)} TMX tokens can be claimed,*/}
        {/*                    use the options under the Total Rewards section to claim them.*/}
        {/*                  </Trans>*/}
        {/*                )}*/}
        {/*              />*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*          <div className="App-card-divider"></div>*/}
        {/*          <div className="App-card-buttons m-0">*/}
        {/*            {!active && (*/}
        {/*              <Button variant="secondary" onClick={openConnectModal}>*/}
        {/*                <Trans>Connect Wallet</Trans>*/}
        {/*              </Button>*/}
        {/*            )}*/}
        {/*            {active && (*/}
        {/*              <Button variant="secondary" onClick={() => showGmxVesterDepositModal()}>*/}
        {/*                <Trans>Deposit</Trans>*/}
        {/*              </Button>*/}
        {/*            )}*/}
        {/*            {active && (*/}
        {/*              <Button variant="secondary" onClick={() => showGmxVesterWithdrawModal()}>*/}
        {/*                <Trans>Withdraw</Trans>*/}
        {/*              </Button>*/}
        {/*            )}*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <div className="App-card StakeV2-gmx-card">*/}
        {/*        <div className="App-card-title">*/}
        {/*          <div className="inline-flex items-center">*/}
        {/*            <img className="mr-5 h-20" alt="TLP" src={icons?.glp} height={20} />*/}
        {/*            <Trans>TLP Vault</Trans>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*        <div className="App-card-divider"></div>*/}
        {/*        <div className="App-card-content">*/}
        {/*          <div className="App-card-row">*/}
        {/*            <div className="label">*/}
        {/*              <Trans>Staked Tokens</Trans>*/}
        {/*            </div>*/}
        {/*            <div>{formatAmount(processedData?.glpBalance, 18, 2, true)} TLP</div>*/}
        {/*          </div>*/}
        {/*          <div className="App-card-row">*/}
        {/*            <div className="label">*/}
        {/*              <Trans>Reserved for Vesting</Trans>*/}
        {/*            </div>*/}
        {/*            <div>*/}
        {/*              {formatKeyAmount(vestingData, "glpVesterPairAmount", 18, 2, true)} /{" "}*/}
        {/*              {formatAmount(processedData?.glpBalance, 18, 2, true)}*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*          <div className="App-card-row">*/}
        {/*            <div className="label">*/}
        {/*              <Trans>Vesting Status</Trans>*/}
        {/*            </div>*/}
        {/*            <div>*/}
        {/*              <Tooltip*/}
        {/*                handle={`${formatKeyAmount(vestingData, "glpVesterClaimSum", 18, 4, true)} / ${formatKeyAmount(*/}
        {/*                  vestingData,*/}
        {/*                  "glpVesterVestedAmount",*/}
        {/*                  18,*/}
        {/*                  4,*/}
        {/*                  true*/}
        {/*                )}`}*/}
        {/*                position="bottom-end"*/}
        {/*                renderContent={() => {*/}
        {/*                  return (*/}
        {/*                    <div>*/}
        {/*                      <Trans>*/}
        {/*                        {formatKeyAmount(vestingData, "glpVesterClaimSum", 18, 4, true)} tokens have been*/}
        {/*                        converted to TMX from the{" "}*/}
        {/*                        {formatKeyAmount(vestingData, "glpVesterVestedAmount", 18, 4, true)} esTMX deposited for*/}
        {/*                        vesting.*/}
        {/*                      </Trans>*/}
        {/*                    </div>*/}
        {/*                  );*/}
        {/*                }}*/}
        {/*              />*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*          <div className="App-card-row">*/}
        {/*            <div className="label">*/}
        {/*              <Trans>Claimable</Trans>*/}
        {/*            </div>*/}
        {/*            <div>*/}
        {/*              <Tooltip*/}
        {/*                handle={`${formatKeyAmount(vestingData, "glpVesterClaimable", 18, 4, true)} TMX`}*/}
        {/*                position="bottom-end"*/}
        {/*                renderContent={() => (*/}
        {/*                  <Trans>*/}
        {/*                    {formatKeyAmount(vestingData, "glpVesterClaimable", 18, 4, true)} TMX tokens can be claimed,*/}
        {/*                    use the options under the Total Rewards section to claim them.*/}
        {/*                  </Trans>*/}
        {/*                )}*/}
        {/*              />*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*          <div className="App-card-divider"></div>*/}
        {/*          <div className="App-card-buttons m-0">*/}
        {/*            {!active && (*/}
        {/*              <Button variant="secondary" onClick={openConnectModal}>*/}
        {/*                <Trans>Connect Wallet</Trans>*/}
        {/*              </Button>*/}
        {/*            )}*/}
        {/*            {active && (*/}
        {/*              <Button variant="secondary" onClick={() => showGlpVesterDepositModal()}>*/}
        {/*                <Trans>Deposit</Trans>*/}
        {/*              </Button>*/}
        {/*            )}*/}
        {/*            {active && (*/}
        {/*              <Button variant="secondary" onClick={() => showGlpVesterWithdrawModal()}>*/}
        {/*                <Trans>Withdraw</Trans>*/}
        {/*              </Button>*/}
        {/*            )}*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      {(vestingData?.affiliateVesterMaxVestableAmount && vestingData?.affiliateVesterMaxVestableAmount > 0 && (*/}
        {/*        <div className="App-card StakeV2-gmx-card">*/}
        {/*          <div className="App-card-title">*/}
        {/*            <div className="inline-flex items-center">*/}
        {/*              <img className="mr-5 h-20" alt="TLP" src={icons?.gmx} height={20} />*/}
        {/*              <Trans>Affiliate Vault</Trans>*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*          <div className="App-card-divider" />*/}
        {/*          <div className="App-card-content">*/}
        {/*            <div className="App-card-row">*/}
        {/*              <div className="label">*/}
        {/*                <Trans>Vesting Status</Trans>*/}
        {/*              </div>*/}
        {/*              <div>*/}
        {/*                <Tooltip*/}
        {/*                  handle={`${formatKeyAmount(*/}
        {/*                    vestingData,*/}
        {/*                    "affiliateVesterClaimSum",*/}
        {/*                    18,*/}
        {/*                    4,*/}
        {/*                    true*/}
        {/*                  )} / ${formatKeyAmount(vestingData, "affiliateVesterVestedAmount", 18, 4, true)}`}*/}
        {/*                  position="bottom-end"*/}
        {/*                  renderContent={() => {*/}
        {/*                    return (*/}
        {/*                      <div>*/}
        {/*                        <Trans>*/}
        {/*                          {formatKeyAmount(vestingData, "affiliateVesterClaimSum", 18, 4, true)} tokens have been*/}
        {/*                          converted to TMX from the{" "}*/}
        {/*                          {formatKeyAmount(vestingData, "affiliateVesterVestedAmount", 18, 4, true)} esTMX*/}
        {/*                          deposited for vesting.*/}
        {/*                        </Trans>*/}
        {/*                      </div>*/}
        {/*                    );*/}
        {/*                  }}*/}
        {/*                />*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*            <div className="App-card-row">*/}
        {/*              <div className="label">*/}
        {/*                <Trans>Claimable</Trans>*/}
        {/*              </div>*/}
        {/*              <div>{formatKeyAmount(vestingData, "affiliateVesterClaimable", 18, 4, true)} TMX</div>*/}
        {/*            </div>*/}
        {/*            <div className="App-card-divider" />*/}
        {/*            <div className="App-card-buttons m-0">*/}
        {/*              {!active && (*/}
        {/*                <Button variant="secondary" onClick={openConnectModal}>*/}
        {/*                  <Trans>Connect Wallet</Trans>*/}
        {/*                </Button>*/}
        {/*              )}*/}
        {/*              {active && (*/}
        {/*                <Button variant="secondary" onClick={() => showAffiliateVesterDepositModal()}>*/}
        {/*                  <Trans>Deposit</Trans>*/}
        {/*                </Button>*/}
        {/*              )}*/}
        {/*              {active && (*/}
        {/*                <Button variant="secondary" onClick={() => showAffiliateVesterWithdrawModal()}>*/}
        {/*                  <Trans>Withdraw</Trans>*/}
        {/*                </Button>*/}
        {/*              )}*/}
        {/*              {active && (*/}
        {/*                <Button variant="secondary" onClick={() => showAffiliateVesterClaimModal()}>*/}
        {/*                  <Trans>Claim</Trans>*/}
        {/*                </Button>*/}
        {/*              )}*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      )) ||*/}
        {/*        null}*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<div className="mt-10">*/}
        {/*  <PageTitle*/}
        {/*    title={t`Incentives & Prizes`}*/}
        {/*    subtitle={*/}
        {/*      incentiveStats?.lp?.isActive || incentiveStats?.trading?.isActive ? (*/}
        {/*        <Trans>Earn {incentivesToken} token incentives by purchasing GM tokens or trading in TMX V2.</Trans>*/}
        {/*      ) : (*/}
        {/*        <Trans>Earn prizes by participating in TMX Trading Competitions.</Trans>*/}
        {/*      )*/}
        {/*    }*/}
        {/*  />*/}
        {/*</div>*/}
        {/*<UserIncentiveDistributionList />*/}
        <Footer />
      </div>
    </SEO>
  );
}
